export default `:host {
    --ui5-avatar-hover-box-shadow-offset: 0px;
    --ui5-avatar-initials-color: var(--sapContent_ImagePlaceholderForegroundColor);
    --ui5-avatar-border-radius: var(--sapElement_BorderCornerRadius);
    --ui5-avatar-border-radius-img-deduction: .0625rem;
    --ui5-avatar-initials-border: .0625rem solid var(--sapAvatar_1_BorderColor);
    --ui5-avatar-optional-border: .0625rem solid var(--sapGroup_ContentBorderColor);
    --ui5-avatar-accent1: var(--sapAvatar_1_Background);
    --ui5-avatar-accent2: var(--sapAvatar_2_Background);
    --ui5-avatar-accent3: var(--sapAvatar_3_Background);
    --ui5-avatar-accent4: var(--sapAvatar_4_Background);
    --ui5-avatar-accent5: var(--sapAvatar_5_Background);
    --ui5-avatar-accent6: var(--sapAvatar_6_Background);
    --ui5-avatar-accent7: var(--sapAvatar_7_Background);
    --ui5-avatar-accent8: var(--sapAvatar_8_Background);
    --ui5-avatar-accent9: var(--sapAvatar_9_Background);
    --ui5-avatar-accent10: var(--sapAvatar_10_Background);
    --ui5-avatar-placeholder: var(--sapContent_ImagePlaceholderBackground);
    --ui5-avatar-accent1-color: var(--sapAvatar_1_TextColor);
    --ui5-avatar-accent2-color: var(--sapAvatar_2_TextColor);
    --ui5-avatar-accent3-color: var(--sapAvatar_3_TextColor);
    --ui5-avatar-accent4-color: var(--sapAvatar_4_TextColor);
    --ui5-avatar-accent5-color: var(--sapAvatar_5_TextColor);
    --ui5-avatar-accent6-color: var(--sapAvatar_6_TextColor);
    --ui5-avatar-accent7-color: var(--sapAvatar_7_TextColor);
    --ui5-avatar-accent8-color: var(--sapAvatar_8_TextColor);
    --ui5-avatar-accent9-color: var(--sapAvatar_9_TextColor);
    --ui5-avatar-accent10-color: var(--sapAvatar_10_TextColor);
    --ui5-avatar-placeholder-color: var(--ui5-avatar-initials-color);
    --ui5-avatar-accent1-border-color: var(--sapAvatar_1_BorderColor);
    --ui5-avatar-accent2-border-color: var(--sapAvatar_2_BorderColor);
    --ui5-avatar-accent3-border-color: var(--sapAvatar_3_BorderColor);
    --ui5-avatar-accent4-border-color: var(--sapAvatar_4_BorderColor);
    --ui5-avatar-accent5-border-color: var(--sapAvatar_5_BorderColor);
    --ui5-avatar-accent6-border-color: var(--sapAvatar_6_BorderColor);
    --ui5-avatar-accent7-border-color: var(--sapAvatar_7_BorderColor);
    --ui5-avatar-accent8-border-color: var(--sapAvatar_8_BorderColor);
    --ui5-avatar-accent9-border-color: var(--sapAvatar_9_BorderColor);
    --ui5-avatar-accent10-border-color: var(--sapAvatar_10_BorderColor);
    --_ui5_avatar_outline: var(--sapContent_FocusWidth) var(--sapContent_FocusStyle) var(--sapContent_FocusColor);
    --_ui5_avatar_focus_offset: .125rem;
    --_ui5_avatar_overflow_button_focus_offset: .0625rem;
    --_ui5_avatar_fontsize_XS: 1rem;
    --_ui5_avatar_fontsize_S: 1.125rem;
    --_ui5_avatar_fontsize_M: 1.5rem;
    --_ui5_avatar_fontsize_L: 2.25rem;
    --_ui5_avatar_fontsize_XL: 3rem;
    --_ui5_avatar_icon_XS: var(--_ui5_avatar_fontsize_XS);
    --_ui5_avatar_icon_S: var(--_ui5_avatar_fontsize_S);
    --_ui5_avatar_icon_M: var(--_ui5_avatar_fontsize_M);
    --_ui5_avatar_icon_L: var(--_ui5_avatar_fontsize_L);
    --_ui5_avatar_icon_XL: var(--_ui5_avatar_fontsize_XL);
    --_ui5_avatar_group_button_focus_border: none;
    --_ui5_avatar_group_padding: .3rem;
    --_ui5-tag-height: 1rem;
    --_ui5-tag-padding-inline-icon-only: .313rem;
    --_ui5-tag-text-padding: .1875rem .25rem;
    --_ui5-tag-text-transform: none;
    --_ui5-tag-icon-width: .75rem;
    --_ui5-tag-icon-gap: .25rem;
    --_ui5-tag-font-weight: normal;
    --_ui5-tag-letter-spacing: normal;
    --ui5-tag-text-shadow: none;
    --ui5-tag-contrast-text-shadow: none;
    --ui5-tag-information-text-shadow: var(--ui5-tag-text-shadow);
    --ui5-tag-set2-color-scheme-1-color: var(--sapIndicationColor_1b_TextColor);
    --ui5-tag-set2-color-scheme-1-background: var(--sapIndicationColor_1b_Background);
    --ui5-tag-set2-color-scheme-1-border: var(--sapIndicationColor_1_BorderColor);
    --ui5-tag-set2-color-scheme-1-hover-background: var(--sapIndicationColor_1_Hover_Background);
    --ui5-tag-set2-color-scheme-1-active-color: var(--sapIndicationColor_1_Active_TextColor);
    --ui5-tag-set2-color-scheme-1-active-background: var(--sapIndicationColor_1_Active_Background);
    --ui5-tag-set2-color-scheme-1-active-border: var(--sapIndicationColor_1_Active_BorderColor);
    --ui5-tag-set2-color-scheme-2-color: var(--sapIndicationColor_2b_TextColor);
    --ui5-tag-set2-color-scheme-2-background: var(--sapIndicationColor_2b_Background);
    --ui5-tag-set2-color-scheme-2-border: var(--sapIndicationColor_2_BorderColor);
    --ui5-tag-set2-color-scheme-2-hover-background: var(--sapIndicationColor_2_Hover_Background);
    --ui5-tag-set2-color-scheme-2-active-color: var(--sapIndicationColor_2_Active_TextColor);
    --ui5-tag-set2-color-scheme-2-active-background: var(--sapIndicationColor_2_Active_Background);
    --ui5-tag-set2-color-scheme-2-active-border: var(--sapIndicationColor_2_Active_BorderColor);
    --ui5-tag-set2-color-scheme-3-color: var(--sapIndicationColor_3b_TextColor);
    --ui5-tag-set2-color-scheme-3-background: var(--sapIndicationColor_3b_Background);
    --ui5-tag-set2-color-scheme-3-border: var(--sapIndicationColor_3_BorderColor);
    --ui5-tag-set2-color-scheme-3-hover-background: var(--sapIndicationColor_3_Hover_Background);
    --ui5-tag-set2-color-scheme-3-active-color: var(--sapIndicationColor_3_Active_TextColor);
    --ui5-tag-set2-color-scheme-3-active-background: var(--sapIndicationColor_3_Active_Background);
    --ui5-tag-set2-color-scheme-3-active-border: var(--sapIndicationColor_3_Active_BorderColor);
    --ui5-tag-set2-color-scheme-4-color: var(--sapIndicationColor_4b_TextColor);
    --ui5-tag-set2-color-scheme-4-background: var(--sapIndicationColor_4b_Background);
    --ui5-tag-set2-color-scheme-4-border: var(--sapIndicationColor_4_BorderColor);
    --ui5-tag-set2-color-scheme-4-hover-background: var(--sapIndicationColor_4_Hover_Background);
    --ui5-tag-set2-color-scheme-4-active-color: var(--sapIndicationColor_4_Active_TextColor);
    --ui5-tag-set2-color-scheme-4-active-background: var(--sapIndicationColor_4_Active_Background);
    --ui5-tag-set2-color-scheme-4-active-border: var(--sapIndicationColor_4_Active_BorderColor);
    --ui5-tag-set2-color-scheme-5-color: var(--sapIndicationColor_5b_TextColor);
    --ui5-tag-set2-color-scheme-5-background: var(--sapIndicationColor_5b_Background);
    --ui5-tag-set2-color-scheme-5-border: var(--sapIndicationColor_5_BorderColor);
    --ui5-tag-set2-color-scheme-5-hover-background: var(--sapIndicationColor_5_Hover_Background);
    --ui5-tag-set2-color-scheme-5-active-color: var(--sapIndicationColor_5_Active_TextColor);
    --ui5-tag-set2-color-scheme-5-active-background: var(--sapIndicationColor_5_Active_Background);
    --ui5-tag-set2-color-scheme-5-active-border: var(--sapIndicationColor_5_Active_BorderColor);
    --ui5-tag-set2-color-scheme-6-color: var(--sapIndicationColor_6b_TextColor);
    --ui5-tag-set2-color-scheme-6-background: var(--sapIndicationColor_6b_Background);
    --ui5-tag-set2-color-scheme-6-border: var(--sapIndicationColor_6_BorderColor);
    --ui5-tag-set2-color-scheme-6-hover-background: var(--sapIndicationColor_6_Hover_Background);
    --ui5-tag-set2-color-scheme-6-active-color: var(--sapIndicationColor_6_Active_TextColor);
    --ui5-tag-set2-color-scheme-6-active-background: var(--sapIndicationColor_6_Active_Background);
    --ui5-tag-set2-color-scheme-6-active-border: var(--sapIndicationColor_6_Active_BorderColor);
    --ui5-tag-set2-color-scheme-7-color: var(--sapIndicationColor_7b_TextColor);
    --ui5-tag-set2-color-scheme-7-background: var(--sapIndicationColor_7b_Background);
    --ui5-tag-set2-color-scheme-7-border: var(--sapIndicationColor_7_BorderColor);
    --ui5-tag-set2-color-scheme-7-hover-background: var(--sapIndicationColor_7_Hover_Background);
    --ui5-tag-set2-color-scheme-7-active-color: var(--sapIndicationColor_7_Active_TextColor);
    --ui5-tag-set2-color-scheme-7-active-background: var(--sapIndicationColor_7_Active_Background);
    --ui5-tag-set2-color-scheme-7-active-border: var(--sapIndicationColor_7_Active_BorderColor);
    --ui5-tag-set2-color-scheme-8-color: var(--sapIndicationColor_8b_TextColor);
    --ui5-tag-set2-color-scheme-8-background: var(--sapIndicationColor_8b_Background);
    --ui5-tag-set2-color-scheme-8-border: var(--sapIndicationColor_8_BorderColor);
    --ui5-tag-set2-color-scheme-8-hover-background: var(--sapIndicationColor_8_Hover_Background);
    --ui5-tag-set2-color-scheme-8-active-color: var(--sapIndicationColor_8_Active_TextColor);
    --ui5-tag-set2-color-scheme-8-active-background: var(--sapIndicationColor_8_Active_Background);
    --ui5-tag-set2-color-scheme-8-active-border: var(--sapIndicationColor_8_Active_BorderColor);
    --ui5-tag-set2-color-scheme-9-color: var(--sapIndicationColor_9b_TextColor);
    --ui5-tag-set2-color-scheme-9-background: var(--sapIndicationColor_9b_Background);
    --ui5-tag-set2-color-scheme-9-border: var(--sapIndicationColor_9_BorderColor);
    --ui5-tag-set2-color-scheme-9-hover-background: var(--sapIndicationColor_9_Hover_Background);
    --ui5-tag-set2-color-scheme-9-active-color: var(--sapIndicationColor_9_Active_TextColor);
    --ui5-tag-set2-color-scheme-9-active-background: var(--sapIndicationColor_9_Active_Background);
    --ui5-tag-set2-color-scheme-9-active-border: var(--sapIndicationColor_9_Active_BorderColor);
    --ui5-tag-set2-color-scheme-10-color: var(--sapIndicationColor_10b_TextColor);
    --ui5-tag-set2-color-scheme-10-background: var(--sapIndicationColor_10b_Background);
    --ui5-tag-set2-color-scheme-10-border: var(--sapIndicationColor_10_BorderColor);
    --ui5-tag-set2-color-scheme-10-hover-background: var(--sapIndicationColor_10_Hover_Background);
    --ui5-tag-set2-color-scheme-10-active-color: var(--sapIndicationColor_10_Active_TextColor);
    --ui5-tag-set2-color-scheme-10-active-background: var(--sapIndicationColor_10_Active_Background);
    --ui5-tag-set2-color-scheme-10-active-border: var(--sapIndicationColor_10_Active_BorderColor);
    --_ui5-tag-height_size_l: 1.5rem;
    --_ui5-tag-min-width_size_l: 1.75rem;
    --_ui5-tag-font-size_size_l: 1.25rem;
    --_ui5-tag-icon_min_width_size_l: 1.25rem;
    --_ui5-tag-icon_min_height_size_l: 1.25rem;
    --_ui5-tag-icon_height_size_l: 1.25rem;
    --_ui5-tag-text_padding_size_l: .125rem .25rem;
    --_ui5_bar_base_height: var(--_ui5-compact-size, 2.5rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_bar_subheader_height: var(--_ui5-compact-size, 2.25rem)  var(--_ui5-cozy-size, 3rem);
    --_ui5_bar-start-container-padding-start: 1rem;
    --_ui5_bar-mid-container-padding-start-end: .5rem;
    --_ui5_bar-end-container-padding-end: 1rem;
    --_ui5_bar_subheader_margin-top: var(--_ui5-light-scheme, -.0625rem) var(--_ui5-dark-scheme, -.125rem);
    --_ui5_breadcrumbs_current_location_color: var(--sapTextColor);
    --_ui5_breadcrumbs_separator_color: var(--sapTextColor);
    --_ui5_busy_indicator_color: var(--sapContent_BusyColor);
    --_ui5_busy_indicator_focus_outline: var(--sapContent_FocusWidth) var(--sapContent_FocusStyle) var(--sapContent_FocusColor);
    --_ui5-button-badge-diameter: var(--_ui5-compact-size, .625rem)  var(--_ui5-cozy-size, .75rem);
    --_ui5-calendar-legend-root-padding: var(--_ui5-compact-size, .5rem)  var(--_ui5-cozy-size, .75rem);
    --_ui5-calendar-legend-root-width: var(--_ui5-compact-size, 16.75rem)  var(--_ui5-cozy-size, 18.5rem);
    --_ui5-calendar-legend-item-box-margin: .25rem;
    --_ui5-calendar-legend-item-root-focus-border: var(--sapContent_FocusWidth) dotted var(--sapContent_FocusColor);
    --_ui5-calendar-legend-item-root-focus-border-radius: 0;
    --_ui5-calendar-legend-item-root-width: 7.75rem;
    --_ui5-calendar-legend-item-box-dot-display: none;
    --_ui5_calendar_header_arrow_button_border: none;
    --_ui5_calendar_header_arrow_button_border_radius: .25rem;
    --_ui5_calendar_header_middle_button_width: 5.75rem;
    --_ui5_calendar_header_middle_button_flex: auto;
    --_ui5_calendar_header_middle_button_focus_border_radius: .5rem;
    --_ui5_calendar_header_middle_button_focus_border: .125rem dotted var(--sapContent_FocusColor);
    --_ui5_calendar_header_middle_button_focus_after_display: none;
    --_ui5_calendar_header_middle_button_focus_after_width: calc(100% - .25rem) ;
    --_ui5_calendar_header_middle_button_focus_after_height: calc(100% - .25rem) ;
    --_ui5_calendar_header_middle_button_focus_after_top_offset: 1px;
    --_ui5_calendar_header_middle_button_focus_after_left_offset: 1px;
    --_ui5_calendar_header_arrow_button_box_shadow: none;
    --_ui5_calendar_header_middle_button_focus_background: transparent;
    --_ui5_calendar_header_middle_button_focus_outline: none;
    --_ui5_calendar_header_middle_button_focus_active_outline: none;
    --_ui5_calendar_header_middle_button_focus_active_background: var(--sapButton_Active_Background);
    --_ui5_calendar_header_middle_button_focus_after_border: 1px dotted var(--sapContent_FocusColor);
    --_ui5_calendar_header_midcontainer_gap: var(--_ui5-compact-size, 0)  var(--_ui5-cozy-size, .5rem);
    --_ui5_calendar_header_arrow_button_flex_shrink: var(--_ui5-compact-size, 1)  var(--_ui5-cozy-size, 0);
    --ui5_carousel_button_size: 2.25rem;
    --ui5_carousel_inactive_dot_size: .5rem;
    --ui5_carousel_inactive_dot_margin: 0 .25rem;
    --ui5_carousel_inactive_dot_border: 1px solid var(--sapContent_ForegroundBorderColor);
    --ui5_carousel_inactive_dot_background: none;
    --ui5_carousel_active_dot_border: var(--ui5_carousel_inactive_dot_border);
    --ui5_carousel_active_dot_background: var(--sapContent_Selected_ForegroundColor);
    --_ui5_card_box_shadow: none;
    --_ui5_card_hover_box_shadow: var(--_ui5_card_box_shadow);
    --_ui5_card_border: 1px solid var(--sapTile_BorderColor);
    --_ui5_card_border-radius: var(--sapTile_BorderCornerRadius);
    --_ui5_card_header_padding: 1rem 1rem .75rem 1rem;
    --_ui5_card_header_hover_bg: var(--sapTile_Hover_Background);
    --_ui5_card_header_active_bg: var(--sapTile_Active_Background);
    --_ui5_card_header_border: none;
    --_ui5_card_header_border_color: var(--sapTile_SeparatorColor);
    --_ui5_card_header_focus_border: .125rem dotted var(--sapContent_FocusColor);
    --_ui5_card_header_focus_radius: 0px;
    --_ui5_card_header_focus_bottom_radius: 0px;
    --_ui5_card_header_focus_offset: 1px;
    --_ui5_card_header_title_font_family: var(--sapFontFamily);
    --_ui5_card_header_title_font_size: var(--sapFontHeader5Size);
    --_ui5_card_header_title_font_weight: normal;
    --_ui5_card_header_subtitle_margin_top: .25rem;
    --_ui5_checkbox_wrapper_padding: var(--_ui5-compact-size, var(--_ui5_checkbox_compact_wrapper_padding))  var(--_ui5-cozy-size, .6875rem);
    --_ui5_checkbox_width_height: var(--_ui5-compact-size, var(--_ui5_checkbox_compact_width_height))  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_checkbox_transition: unset;
    --_ui5_checkbox_disabled_opacity: var(--sapContent_DisabledOpacity);
    --_ui5_checkbox_border_radius: 0;
    --_ui5_checkbox_hover_background: var(--sapSelectedColor);
    --_ui5_checkbox_active_background: var(--sapSelectedColor);
    --_ui5_checkbox_checkmark_warning_color: var(--sapField_WarningColor);
    --_ui5_checkbox_inner_warning_color: var(--sapField_WarningColor);
    --_ui5_checkbox_inner_information_color: var(--sapField_InformationColor);
    --_ui5_checkbox_checkmark_color: var(--sapContent_Selected_ForegroundColor);
    --_ui5_checkbox_focus_position: var(--_ui5-compact-size, .125rem)  var(--_ui5-cozy-size, .3125rem);
    --_ui5_checkbox_focus_outline: var(--sapContent_FocusWidth) var(--sapContent_FocusStyle) var(--sapContent_FocusColor);
    --_ui5_checkbox_focus_border_radius: 0;
    --_ui5_checkbox_outer_hover_background: transparent;
    --_ui5_checkbox_inner_width_height: var(--_ui5-compact-size, var(--_ui5_checkbox_compact_inner_size))  var(--_ui5-cozy-size, 1.375rem);
    --_ui5_checkbox_inner_border: solid var(--sapField_BorderWidth) var(--sapField_BorderColor);
    --_ui5_checkbox_inner_hover_border_color: var(--sapField_Hover_BorderColor);
    --_ui5_checkbox_inner_hover_checked_border_color: var(--sapField_Hover_BorderColor);
    --_ui5_checkbox_inner_selected_border_color: var(--sapField_Hover_BorderColor);
    --_ui5_checkbox_inner_disabled_border_color: var(--sapField_BorderColor);
    --_ui5_checkbox_inner_active_border_color: var(--sapField_Hover_BorderColor);
    --_ui5_checkbox_inner_border_radius: var(--sapField_BorderCornerRadius);
    --_ui5_checkbox_inner_error_border: var(--sapField_InvalidBorderWidth) dashed var(--sapField_InvalidColor);
    --_ui5_checkbox_inner_warning_border: var(--sapField_WarningBorderWidth) dashed var(--sapField_WarningColor);
    --_ui5_checkbox_inner_information_border: var(--sapField_InformationBorderWidth) dashed var(--sapField_InformationColor);
    --_ui5_checkbox_inner_warning_background_hover: var(--sapField_Hover_Background);
    --_ui5_checkbox_inner_error_background_hover: var(--sapField_InvalidBackground);
    --_ui5_checkbox_inner_success_background_hover: var(--sapField_Hover_Background);
    --_ui5_checkbox_inner_information_background_hover: var(--sapField_Hover_Background);
    --_ui5_checkbox_inner_success_border: var(--sapField_SuccessBorderWidth) solid var(--sapField_SuccessColor);
    --_ui5_checkbox_inner_readonly_border: var(--sapElement_BorderWidth) var(--sapField_ReadOnly_BorderColor) solid;
    --_ui5_checkbox_inner_background: var(--sapField_Background);
    --_ui5_checkbox_wrapped_focus_padding: .5rem;
    --_ui5_checkbox_wrapped_focus_inset_block: var(--_ui5-compact-size, .125rem)  var(--_ui5-cozy-size, var(--_ui5_checkbox_focus_position));
    --_ui5_checkbox_compact_wrapper_padding: .5rem;
    --_ui5_checkbox_compact_width_height: 2rem;
    --_ui5_checkbox_compact_inner_size: 1rem;
    --_ui5_checkbox_compact_focus_position: .375rem;
    --_ui5_checkbox_label_color: var(--sapField_TextColor);
    --_ui5_checkbox_label_offset: var(--_ui5-compact-size, var(--_ui5_checkbox_compact_wrapper_padding))  var(--_ui5-cozy-size, var(--_ui5_checkbox_wrapper_padding));
    --_ui5_checkbox_disabled_label_color: var(--sapContent_LabelColor);
    --_ui5_checkbox_default_focus_border: none;
    --_ui5_checkbox_focus_outline_display: block;
    --_ui5_checkbox_right_focus_distance: .3125rem;
    --_ui5_checkbox_icon_size: var(--_ui5-compact-size, .75rem)  var(--_ui5-cozy-size, 1rem);
    --_ui5_color-palette-item-after-focus-border-radius: .125rem;
    --_ui5_color-palette-item-hover-margin: var(--_ui5-compact-size, 0)  var(--_ui5-cozy-size, 0);
    --_ui5_color-palette-row-height: var(--_ui5-compact-size, 7.5rem)  var(--_ui5-cozy-size, 9.5rem);
    --_ui5_color-palette-button-height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 3rem);
    --_ui5_color-palette-item-before-focus-color: .125rem solid white;
    --_ui5_color-palette-item-before-focus-inset: .0625rem;
    --_ui5_color-palette-item-before-focus-hover-inset: .0625rem;
    --_ui5_color-palette-item-after-focus-color: .125rem dotted black;
    --_ui5_color-palette-item-after-focus-inset: .0625rem;
    --_ui5_color-palette-item-after-focus-hover-inset: .0625rem;
    --_ui5_color-palette-item-before-focus-border-radius: 0;
    --_ui5_color-palette-item-outer-border-radius: .25rem;
    --_ui5_color-palette-item-inner-border-radius: .1875rem;
    --_ui5_color-palette-item-hover-outer-border-radius: .25rem;
    --_ui5_color-palette-item-hover-inner-border-radius: .1875rem;
    --_ui5_color-palette-item-selected-focused-border-before: var(--_ui5_color-palette-item-before-focus-hover-inset);
    --_ui5_color-palette-item-after-focus-not-selected-border: .125rem dotted black;
    --_ui5_color-palette-item-after-not-focus-color: .0625rem solid var(--sapGroup_ContentBackground);
    --_ui5_color-palette-item-selected-focused-border: .0625rem solid var(--sapGroup_ContentBackground);
    --_ui5-color-palette-item-mobile-focus-inset: .625rem;
    --_ui5_color-palette-item-mobile-focus-sides-inset: .25rem .25rem;
    --_ui5_color-palette-item-after-mobile-focus-border: var(--_ui5_color-palette-item-after-focus-color);
    --_ui5-color-palette-item-background-color: transparent;
    --_ui5_color_picker_slider_handle_box_shadow: inset 0 0 0 .125rem var(--sapContent_ForegroundColor);
    --_ui5_color_picker_slider_handle_border: .125rem solid var(--sapField_BorderColor);
    --_ui5_color_picker_slider_handle_outline_hover: .125rem solid var(--sapButton_Hover_BorderColor);
    --_ui5_color_picker_slider_handle_outline_focus: .0625rem dotted var(--sapContent_FocusColor);
    --_ui5_color_picker_slider_handle_inner_border_color: var(--sapContent_ForegroundColor);
    --_ui5_color_picker_circle_outer_border: .125rem solid var(--sapContent_ContrastShadowColor);
    --_ui5_color_picker_circle_inner_border: var(--sapField_Picker_BorderWidth) solid var(--sapContent_ForegroundColor);
    --_ui5_color_picker_circle_inner_circle_size: .3125rem;
    --_ui5_color_picker_slider_handle_inline_focus: none;
    --_ui5_color_picker_slider_handle_container_margin_top: var(--_ui5-compact-size, .0625rem)  var(--_ui5-cozy-size, none);
    --_ui5-datepicker_border_radius: 0;
    --_ui5-datepicker-hover-background: var(--sapField_Hover_Background);
    --_ui5_daypicker_item_margin: 2px;
    --_ui5_daypicker_item_border: none;
    --_ui5_daypicker_item_selected_border_color: var(--sapList_Background);
    --_ui5_daypicker_daynames_container_height: 2rem;
    --_ui5_daypicker_weeknumbers_container_padding_top: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2rem);
    --_ui5_daypicker_item_othermonth_background_color: var(--sapList_Background);
    --_ui5_daypicker_item_othermonth_color: var(--sapContent_LabelColor);
    --_ui5_daypicker_item_othermonth_hover_color: var(--sapContent_LabelColor);
    --_ui5_daypicker_item_border_radius: .4375rem;
    --_ui5_daypicker_dayname_color: var(--sapContent_LabelColor);
    --_ui5_daypicker_weekname_color: var(--sapContent_LabelColor);
    --_ui5_daypicker_item_now_selected_outline_offset: -.25rem;
    --_ui5_daypicker_item_selected_background: transparent;
    --_ui5_daypicker_item_selected_daytext_hover_background: transparent;
    --_ui5_daypicker_item_border_radius_focus_after: .1875rem;
    --_ui5_daypicker_item_selected_between_border: .5rem;
    --_ui5_daypicker_item_selected_between_background: var(--sapList_SelectionBackgroundColor);
    --_ui5_daypicker_item_selected_between_text_font: var(--sapFontFamily);
    --_ui5_daypicker_item_selected_between_hover_background: var(--sapList_Hover_SelectionBackground);
    --_ui5_daypicker_item_now_box_shadow: inset 0 0 0 .35rem var(--sapList_Background);
    --_ui5_daypicker_item_selected_text_outline: .0625rem solid var(--sapSelectedColor);
    --_ui5_daypicker_item_now_not_selected_inset: 0;
    --_ui5_daypicker_item_now_inset: .3125rem;
    --_ui5_daypicker_item_now_border_color: var(--sapLegend_CurrentDateTime);
    --_ui5_daypicker_item_weeekend_filter: brightness(105%);
    --_ui5_daypicker_item_selected_hover: var(--sapList_Hover_Background);
    --_ui5_daypicker_item_border_radius_item: .5rem;
    --_ui5_daypicker_two_calendar_item_now_inset: .3125rem;
    --_ui5_daypicker_item_selected__secondary_type_text_outline: .0625rem solid var(--sapSelectedColor);
    --_ui5_daypicker_two_calendar_item_now_day_text_content: "";
    --_ui5_daypicker_two_calendar_item_now_selected_border_width: .125rem;
    --_ui5_daypicker_two_calendar_item_border_radius: .5rem;
    --_ui5_daypicker_two_calendar_item_border_focus_border_radius: .375rem;
    --_ui5_daypicker_two_calendar_item_no_selected_inset: 0;
    --_ui5_daypicker_two_calendar_item_selected_now_border_radius_focus: .1875rem;
    --_ui5_daypicker_two_calendar_item_no_selected_focus_inset: .1875rem;
    --_ui5_daypicker_two_calendar_item_no_select_focus_border_radius: .3125rem;
    --_ui5_dp_two_calendar_item_secondary_text_border_radios: .25rem;
    --_ui5_daypicker_two_calendar_item_now_selected_border_inset: .125rem;
    --_ui5_daypicker_special_day_top: var(--_ui5-compact-size, 1.625rem)  var(--_ui5-cozy-size, 2.5rem);
    --_ui5_daypicker_special_day_border_bottom_radius: .5rem;
    --_ui5_daypicker_special_day_before_border_color: var(--sapList_Background);
    --_ui5_daypicker_selected_item_special_day_width: calc(100% - .125rem) ;
    --_ui5_daypicker_selected_item_now_special_day_top: var(--_ui5-compact-size, 1.5625rem)  var(--_ui5-cozy-size, 2.4375rem);
    --_ui5_daypicker_selected_item_now_special_day_width: calc(100% - .1875rem) ;
    --_ui5_daypicker_selected_item_now_special_day_border_bottom_radius: 0;
    --_ui5-daypicker_item_selected_now_border_radius: .5rem;
    --_ui5_daypicker_selected_item_now_special_day_border_bottom_radius_alternate: var(--_ui5-compact-size, .5rem)  var(--_ui5-cozy-size, .5rem);
    --_ui5_daypicker_two_calendar_item_margin_bottom: var(--_ui5-compact-size, 0)  var(--_ui5-cozy-size, 0);
    --_ui5_daypicker_twocalendar_item_special_day_now_inset: .3125rem;
    --_ui5_daypicker_twocalendar_item_special_day_now_border_radius: .25rem;
    --_ui5_daypicker_item_now_focus_margin: 0;
    --_ui5_daypicker_special_day_border_top: none;
    --_ui5_daypicker_special_day_selected_border_radius_bottom: .25rem;
    --_ui5_daypicker_specialday_focused_top: var(--_ui5-compact-size, 1.3125rem)  var(--_ui5-cozy-size, 2.125rem);
    --_ui5_daypicker_specialday_focused_width: calc(100% - .75rem) ;
    --_ui5_daypicker_specialday_focused_border_bottom: var(--_ui5-compact-size, .25rem)  var(--_ui5-cozy-size, 0);
    --_ui5_daypicker_item_now_specialday_top: var(--_ui5-compact-size, 1.4375rem)  var(--_ui5-cozy-size, 2.3125rem);
    --_ui5_daypicker_item_now_specialday_width: calc(100% - .5rem) ;
    --_ui5_daypicker_twocalendar_item_special_day_after_border_width: .125rem;
    --_ui5_daypicker_twocalendar_item_special_day_dot: .375rem;
    --_ui5_daypicker_twocalendar_item_special_day_top: var(--_ui5-compact-size, 1.25rem)  var(--_ui5-cozy-size, 2rem);
    --_ui5_daypicker_twocalendar_item_special_day_right: var(--_ui5-compact-size, 1.25rem)  var(--_ui5-cozy-size, 1.4375rem);
    --_ui5_daypicker_item_selected_border: .0625rem solid var(--sapList_SelectionBorderColor);
    --_ui5_daypicker_item_not_selected_focus_border: .125rem solid var(--sapContent_FocusColor);
    --_ui5_daypicker_item_selected_focus_color: var(--sapContent_FocusColor);
    --_ui5_daypicker_item_selected_focus_width: .125rem;
    --_ui5_daypicker_item_no_selected_inset: .375rem;
    --_ui5_daypicker_item_now_border_focus_after: .125rem solid var(--sapList_SelectionBorderColor);
    --_ui5_daypicker_item_now_border_radius_focus_after: .3125rem;
    --_ui5_day_picker_item_selected_now_border_focus: .125rem solid var(--sapContent_FocusColor);
    --_ui5_day_picker_item_selected_now_border_radius_focus: .1875rem;
    --_ui5_daypicker_item_selected_text_font: var(--sapFontBoldFamily);
    --_ui5_daypicker_item_now_selected_between_inset: .25rem;
    --_ui5_daypicker_item_now_selected_between_border: .0625rem solid var(--sapContent_Selected_ForegroundColor);
    --_ui5_daypicker_item_now_selected_between_border_radius: .1875rem;
    --_ui5_daypicker_item_select_between_border: 1px solid var(--sapContent_Selected_ForegroundColor);
    --_ui5-dp-item_withsecondtype_border: .25rem;
    --_ui5_dialog_header_focus_bottom_offset: 3px;
    --_ui5_dialog_header_focus_top_offset: 2px;
    --_ui5_dialog_header_focus_left_offset: 2px;
    --_ui5_dialog_header_focus_right_offset: 2px;
    --_ui5_dialog_header_border_radius: 0px;
    --_ui5_dialog_header_state_line_height: .125rem;
    --_ui5_file_uploader_display_input_width: calc(100% - var(--_ui5_input_icon_width));
    --_ui5_file_uploader_tokenizer_width: calc(100% - 2 * var(--_ui5_input_icon_width) - var(--_ui5_input_inner_space_to_tokenizer));
    --ui5-group-header-listitem-background-color: var(--sapList_GroupHeaderBackground);
    --_ui5_input_width: 13.125rem;
    --_ui5_input_min_width: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_input_min_width_tokenizer_available: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 3rem);
    --_ui5_input_height: var(--_ui5-compact-size, var(--sapElement_Compact_Height))  var(--_ui5-cozy-size, var(--sapElement_Height));
    --_ui5_input_margin_top_bottom: var(--_ui5-compact-size, .1875rem)  var(--_ui5-cozy-size, .25rem);
    --_ui5_input_hover_border: var(--sapField_BorderWidth) var(--sapField_BorderStyle) var(--sapField_Hover_BorderColor);
    --_ui5_input_value_state_error_hover_background: var(--sapField_InvalidBackground);
    --_ui5_input_background_color: var(--sapField_Background);
    --_ui5_input_border_radius: var(--sapField_BorderCornerRadius);
    --_ui5_input_focus_border_radius: 0;
    --_ui5_input_readonly_focus_border_radius: 0;
    --_ui5-input-border: var(--sapField_BorderWidth) var(--sapField_BorderStyle) var(--sapField_BorderColor);
    --_ui5_input_placeholder_style: normal;
    --_ui5_input_placeholder_color: var(--sapField_PlaceholderTextColor);
    --_ui5_input_bottom_border_height: 0;
    --_ui5_input_bottom_border_color: transparent;
    --_ui5_input_focused_border_color: var(--sapField_Hover_BorderColor);
    --_ui5_input_state_border_width: .125rem;
    --_ui5_input_information_border_width: .0625rem;
    --_ui5_input_error_font_weight: bold;
    --_ui5_input_warning_font_weight: bold;
    --_ui5_input_focus_border_width: .125rem;
    --_ui5_input_error_warning_border_style: dashed;
    --_ui5_input_error_warning_font_style: italic;
    --_ui5_input_error_warning_text_indent: .125rem;
    --_ui5_input_disabled_border_color: var(--sapField_BorderColor);
    --_ui5-input_disabled_background: var(--sapField_Background);
    --_ui5_input_readonly_border: var(--sapElement_BorderWidth) var(--sapField_BorderStyle) var(--sapField_BorderColor);
    --_ui5_input_readonly_border_color: var(--sapField_ReadOnly_BorderColor);
    --_ui5_input_readonly_background: var(--sapField_ReadOnly_Background);
    --_ui5_input_custom_icon_padding: var(--_ui5-compact-size, .1875rem .5rem)  var(--_ui5-cozy-size, .5rem .625rem);
    --_ui5_input_error_warning_custom_icon_padding: var(--_ui5-compact-size, .1875rem .5rem)  var(--_ui5-cozy-size, .5rem .625rem);
    --_ui5_input_error_warning_custom_focused_icon_padding: var(--_ui5-compact-size, .1875rem .5rem)  var(--_ui5-cozy-size, .5rem .625rem);
    --_ui5_input_information_custom_icon_padding: var(--_ui5-compact-size, .1875rem .5rem)  var(--_ui5-cozy-size, .5rem .625rem);
    --_ui5_input_information_custom_focused_icon_padding: var(--_ui5-compact-size, .1875rem .5rem)  var(--_ui5-cozy-size, .5rem .625rem);
    --_ui5_input_error_warning_icon_padding: var(--_ui5-compact-size, .1875rem .375rem .1875rem .4375rem)  var(--_ui5-cozy-size, .5rem .5rem .5rem .5625rem);
    --_ui5_input_error_warning_focused_icon_padding: var(--_ui5-compact-size, .1875rem .375rem .1875rem .4375rem)  var(--_ui5-cozy-size, .5rem .5rem .5rem .5625rem);
    --_ui5_input_information_icon_padding: var(--_ui5-compact-size, .1875rem .375rem .1875rem .4375rem)  var(--_ui5-cozy-size, .5rem .5rem .5rem .5625rem);
    --_ui5_input_information_focused_icon_padding: var(--_ui5-compact-size, .1875rem .375rem .1875rem .4375rem)  var(--_ui5-cozy-size, .5rem .5rem .5rem .5625rem);
    --_ui5_input_disabled_opacity: var(--sapContent_DisabledOpacity);
    --_ui5_input_icon_min_width: var(--_ui5-compact-size, var(--_ui5_input_compact_min_width))  var(--_ui5-cozy-size, 2.25rem);
    --_ui5_input_compact_min_width: 2rem;
    --_ui5_input_transition: none;
    --_ui5-input-value-state-icon-display: none;
    --_ui5_input_focused_value_state_error_background: var(--sapField_InvalidBackground);
    --_ui5_input_focused_value_state_warning_background: var(--sapField_WarningBackground);
    --_ui5_input_focused_value_state_success_background: var(--sapField_SuccessBackground);
    --_ui5_input_focused_value_state_information_background: var(--sapField_InformationBackground);
    --_ui5_input_value_state_error_border_color: var(--sapField_InvalidColor);
    --_ui5_input_focused_value_state_error_border_color: var(--sapField_InvalidColor);
    --_ui5_input_focused_value_state_error_focus_outline_color: var(--sapContent_FocusColor);
    --_ui5_input_focused_value_state_warning_focus_outline_color: var(--sapContent_FocusColor);
    --_ui5_input_focused_value_state_success_focus_outline_color: var(--sapContent_FocusColor);
    --_ui5_input_value_state_warning_border_color: var(--sapField_WarningColor);
    --_ui5_input_focused_value_state_warning_border_color: var(--sapField_WarningColor);
    --_ui5_input_value_state_success_border_color: var(--sapField_SuccessColor);
    --_ui5_input_focused_value_state_success_border_color: var(--sapField_SuccessColor);
    --_ui5_input_value_state_success_border_width: var(--sapField_BorderWidth);
    --_ui5_input_value_state_information_border_color: var(--sapField_InformationColor);
    --_ui5_input_focused_value_state_information_border_color: var(--sapField_InformationColor);
    --_ui5_input_focus_offset: 1px;
    --_ui5_input_readonly_focus_offset: 1px;
    --ui5_input_focus_pseudo_element_content: "";
    --_ui5_input_value_state_error_warning_placeholder_font_weight: bold;
    --_ui5_input_focus_outline_color: var(--sapField_Active_BorderColor);
    --_ui5-input_error_placeholder_color: var(--sapField_TextColor);
    --_ui5_input_icon_width: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.25rem);
    --_ui5_input_icon_wrapper_height: 100%;
    --_ui5_input_icon_wrapper_state_height: 100%;
    --_ui5_input_icon_wrapper_success_state_height: 100%;
    --_ui5-input-icons-count: 0;
    --_ui5_input_tokenizer_min_width: 3.5rem;
    --_ui5_input_icon_padding: var(--_ui5-compact-size, .1875rem .375rem .1875rem .4375rem)  var(--_ui5-cozy-size, .5rem .5rem .5rem .5625rem);
    --_ui5_input_icon_color: var(--sapField_TextColor);
    --_ui5_input_icon_pressed_color: var(--sapButton_Active_TextColor);
    --_ui5_input_icon_pressed_bg: var(--sapField_Hover_Background);
    --_ui5_input_icon_hover_bg: var(--sapButton_Lite_Hover_Background);
    --_ui5_input_icon_border_radius: 0;
    --_ui5_input_icon_box_shadow: none;
    --_ui5_input_icon_border: 1px solid transparent;
    --_ui5_input_error_icon_box_shadow: var(--_ui5_input_icon_box_shadow);
    --_ui5_input_warning_icon_box_shadow: var(--_ui5_input_icon_box_shadow);
    --_ui5_input_information_icon_box_shadow: var(--_ui5_input_icon_box_shadow);
    --_ui5_input_success_icon_box_shadow: var(--_ui5_input_icon_box_shadow);
    --_ui5_input_icon_error_pressed_color: var(--sapButton_Active_TextColor);
    --_ui5_input_icon_warning_pressed_color: var(--sapButton_Active_TextColor);
    --_ui5_input_icon_information_pressed_color: var(--sapButton_Active_TextColor);
    --_ui5_input_icon_success_pressed_color: var(--sapButton_Active_TextColor);
    --_ui5_link_text_decoration: var(--sapLink_TextDecoration);
    --_ui5_link_hover_text_decoration: var(--sapLink_Hover_TextDecoration);
    --_ui5_link_focused_hover_text_decoration: none;
    --_ui5_link_focused_hover_text_color: var(--sapLinkColor);
    --_ui5_link_active_text_decoration: var(--sapLink_Active_TextDecoration);
    --_ui5_link_outline: .125rem dotted var(--sapContent_FocusColor);
    --_ui5_link_focus_border-radius: 0;
    --_ui5_link_focus_background_color: transparent;
    --_ui5_link_focus_color: var(--sapLinkColor);
    --_ui5_link_focus_text_decoration: underline;
    --_ui5_link_subtle_text_decoration: underline;
    --_ui5_link_subtle_text_decoration_hover: none;
    --_ui5_link_large_interactive_area_height: 1.5rem;
    --ui5_list_footer_text_color: var(--sapPageFooter_TextColor);
    --_ui5_list_buttons_left_space: var(--_ui5-compact-size, .125rem)  var(--_ui5-cozy-size, .125rem);
    --ui5-listitem-background-color: var(--sapList_Background);
    --ui5-listitem-border-bottom: var(--sapList_BorderWidth) solid var(--sapList_BorderColor);
    --ui5-listitem-selected-border-bottom: 1px solid var(--sapList_SelectionBorderColor);
    --ui5-listitem-focused-selected-border-bottom: 1px solid var(--sapList_SelectionBorderColor);
    --_ui5-listitembase_disabled_opacity: .5;
    --_ui5_product_switch_item_border: none;
    --_ui5_menu_popover_border_radius: var(--sapPopover_BorderCornerRadius);
    --_ui5_menu_item_padding: var(--_ui5-compact-size, 0 .75rem 0 .5rem)  var(--_ui5-cozy-size, 0 1rem 0 .75rem);
    --_ui5_menu_item_submenu_icon_right: var(--_ui5-compact-size, .75rem)  var(--_ui5-cozy-size, 1rem);
    --_ui5_monthpicker_item_margin: .0625rem;
    --_ui5_monthpicker_item_border: .0625rem solid var(--sapButton_Lite_BorderColor);
    --_ui5_monthpicker_item_border_radius: .5rem;
    --_ui5_monthpicker_item_hover_border: .0625rem solid var(--sapButton_Lite_Hover_BorderColor);
    --_ui5_monthpicker_item_active_border: .0625rem solid var(--sapButton_Lite_Active_BorderColor);
    --_ui5_monthpicker_item_selected_border: .0625rem solid var(--sapButton_Selected_BorderColor);
    --_ui5_monthpicker_item_selected_hover_border: .0625rem solid var(--sapButton_Selected_Hover_BorderColor);
    --_ui5_message_strip_padding: .4375rem 2.5rem .4375rem 2.5rem;
    --_ui5_message_strip_padding_block_no_icon: .4375rem .4375rem;
    --_ui5_message_strip_padding_inline_no_icon: 1rem 2.5rem;
    --_ui5_message_strip_border_width: var(--sapMessage_BorderWidth);
    --_ui5_message_strip_icon_top: .375rem;
    --_ui5_message_strip_close_button_top: .125rem;
    --_ui5_message_strip_close_button_right: .125rem;
    --_ui5_message_strip_close_button_color_set_1_background: var(--sapMessage_Button_Hover_Background);
    --_ui5_message_strip_close_button_color_set_2_background: var(--sapMessage_Button_Hover_Background);
    --_ui5_message_strip_close_button_color_set_1_color: var(--sapContent_ContrastIconColor);
    --_ui5_message_strip_scheme_1_set_2_background: var(--sapIndicationColor_1_Background);
    --_ui5_message_strip_scheme_1_set_2_border_color: var(--sapIndicationColor_1_BorderColor);
    --_ui5_message_strip_scheme_2_set_2_background: var(--sapIndicationColor_2_Background);
    --_ui5_message_strip_scheme_2_set_2_border_color: var(--sapIndicationColor_2_BorderColor);
    --_ui5_message_strip_scheme_3_set_2_background: var(--sapIndicationColor_3_Background);
    --_ui5_message_strip_scheme_3_set_2_border_color: var(--sapIndicationColor_3_BorderColor);
    --_ui5_message_strip_scheme_4_set_2_background: var(--sapIndicationColor_4_Background);
    --_ui5_message_strip_scheme_4_set_2_border_color: var(--sapIndicationColor_4_BorderColor);
    --_ui5_message_strip_scheme_5_set_2_background: var(--sapIndicationColor_5_Background);
    --_ui5_message_strip_scheme_5_set_2_border_color: var(--sapIndicationColor_5_BorderColor);
    --_ui5_message_strip_scheme_6_set_2_background: var(--sapIndicationColor_6_Background);
    --_ui5_message_strip_scheme_6_set_2_border_color: var(--sapIndicationColor_6_BorderColor);
    --_ui5_message_strip_scheme_7_set_2_background: var(--sapIndicationColor_7_Background);
    --_ui5_message_strip_scheme_7_set_2_border_color: var(--sapIndicationColor_7_BorderColor);
    --_ui5_message_strip_scheme_8_set_2_background: var(--sapIndicationColor_8_Background);
    --_ui5_message_strip_scheme_8_set_2_border_color: var(--sapIndicationColor_8_BorderColor);
    --_ui5_message_strip_scheme_9_set_2_background: var(--sapIndicationColor_9_Background);
    --_ui5_message_strip_scheme_9_set_2_border_color: var(--sapIndicationColor_9_BorderColor);
    --_ui5_message_strip_scheme_10_set_2_background: var(--sapIndicationColor_10_Background);
    --_ui5_message_strip_scheme_10_set_2_border_color: var(--sapIndicationColor_10_BorderColor);
    --_ui5_panel_focus_border: .125rem dotted var(--sapContent_FocusColor);
    --_ui5_panel_header_height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_panel_button_root_width: var(--_ui5-compact-size, 2.75rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_panel_button_root_height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_panel_border_radius: 0px;
    --_ui5_panel_border_radius_expanded: 0;
    --_ui5_panel_default_header_border: .0625rem solid var(--sapGroup_TitleBorderColor);
    --_ui5_panel_border_bottom: var(--sapGroup_TitleBorderWidth) solid var(--sapGroup_TitleBorderColor);
    --_ui5_panel_icon_color: var(--sapButton_Lite_TextColor);
    --_ui5_panel_header_padding_right: .5rem;
    --_ui5_panel_header_button_wrapper_padding: var(--_ui5-compact-size, .1875rem .25rem)  var(--_ui5-cozy-size, .25rem);
    --_ui5_panel_focus_offset: 1px;
    --_ui5_panel_focus_bottom_offset: var(--_ui5_panel_focus_offset);
    --_ui5_panel_content_padding: .625rem 1rem;
    --_ui5_panel_header_background_color: var(--sapGroup_TitleBackground);
    --_ui5_popover_background: var(--sapGroup_ContentBackground);
    --_ui5_popover_box_shadow: var(--sapContent_Shadow2);
    --_ui5_popover_no_arrow_box_shadow: var(--sapContent_Shadow1);
    --_ui5_popup_block_layer_background: var(--sapBlockLayer_Background);
    --_ui5_popup_block_layer_opacity: .3;
    --_ui5_popup_content_padding_s: 1rem;
    --_ui5_popup_content_padding_m_l: 2rem;
    --_ui5_popup_content_padding_xl: 3rem;
    --_ui5_popup_header_footer_padding_s: 1rem;
    --_ui5_popup_header_footer_padding_m_l: 2rem;
    --_ui5_popup_header_footer_padding_xl: 3rem;
    --_ui5_popup_viewport_margin: 10px;
    --_ui5_popup_header_prop_header_text_alignment: flex-start;
    --_ui5_popup_border_radius: .5rem;
    --_ui5_popup_header_shadow: var(--sapContent_HeaderShadow);
    --_ui5_popup_header_border: none;
    --_ui5_progress_indicator_background_none: var(--sapField_Background);
    --_ui5_progress_indicator_background_error: var(--sapField_Background);
    --_ui5_progress_indicator_background_warning: var(--sapField_Background);
    --_ui5_progress_indicator_background_success: var(--sapField_Background);
    --_ui5_progress_indicator_background_information: var(--sapField_Background);
    --_ui5_progress_indicator_value_state_none: var(--sapHighlightColor);
    --_ui5_progress_indicator_value_state_error: var(--sapHighlightColor);
    --_ui5_progress_indicator_value_state_warning: var(--sapHighlightColor);
    --_ui5_progress_indicator_value_state_success: var(--sapHighlightColor);
    --_ui5_progress_indicator_value_state_information: var(--sapHighlightColor);
    --_ui5_progress_indicator_border_color_error: var(--sapField_BorderColor);
    --_ui5_progress_indicator_border_color_warning: var(--sapField_BorderColor);
    --_ui5_progress_indicator_border_color_success: var(--sapField_BorderColor);
    --_ui5_progress_indicator_border_color_information: var(--sapField_BorderColor);
    --_ui5_progress_indicator_color: var(--sapTextColor);
    --_ui5_progress_indicator_bar_color: var(--sapProgress_TextColor);
    --_ui5_progress_indicator_border: .0625rem solid var(--sapField_BorderColor);
    --_ui5_progress_indicator_bar_border_max: var(--_ui5_progress_indicator_border);
    --_ui5_progress_indicator_icon_visibility: inline-block;
    --_ui5_progress_indicator_side_points_visibility: block;
    --_ui5_progress_indicator_padding_novalue: .3125rem;
    --_ui5_progress_indicator_host_height: unset;
    --_ui5_progress_indicator_root_border_radius: .25rem;
    --_ui5_progress_indicator_root_height: .375rem;
    --_ui5_progress_indicator_root_overflow: visible;
    --_ui5_progress_indicator_bar_height: .625rem;
    --_ui5_progress_indicator_bar_border_radius: .5rem;
    --_ui5_progress_indicator_remaining_bar_overflow: visible;
    --_ui5_progress_indicator_icon_size: var(--sapFontLargeSize);
    --_ui5_progress_indicator_value_margin: 0 0 .1875rem 0;
    --_ui5_progress_indicator_padding: 1.25rem 0 .75rem 0;
    --_ui5_progress_indicator_padding_end: 1.25rem;
    --_ui5_progress_indicator_host_box_sizing: border-box;
    --_ui5_progress_indicator_root_position: relative;
    --_ui5_progress_indicator_root_min_height: .375rem;
    --_ui5_progress_indicator_remaining_bar_border_radius: 0 .5rem .5rem 0;
    --_ui5_progress_indicator_remaining_bar_position: absolute;
    --_ui5_progress_indicator_remaining_bar_width: 100%;
    --_ui5_progress_indicator_icon_position: absolute;
    --_ui5_progress_indicator_icon_right_position: -1.25rem;
    --_ui5_progress_indicator_value_position: absolute;
    --_ui5_progress_indicator_value_top_position: -1.3125rem;
    --_ui5_progress_indicator_value_left_position: 0;
    --_ui5_radio_button_min_width: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_radio_button_hover_fill: var(--sapField_Selector_Hover_Background);
    --_ui5_radio_button_hover_fill_error: var(--sapField_Selector_Hover_InvalidBackground);
    --_ui5_radio_button_hover_fill_warning: var(--sapField_Selector_Hover_WarningBackground);
    --_ui5_radio_button_hover_fill_success: var(--sapField_Selector_Hover_SuccessBackground);
    --_ui5_radio_button_hover_fill_information: var(--sapField_Selector_Hover_InformationBackground);
    --_ui5_radio_button_border_width: .125rem;
    --_ui5_radio_button_checked_fill: var(--sapContent_IconColor);
    --_ui5_radio_button_checked_error_fill: light-dark(var(--sapContent_IconColor), var(--sapField_InvalidColor));
    --_ui5_radio_button_checked_warning_fill: light-dark(var(--sapContent_IconColor), var(--sapField_TextColor));
    --_ui5_radio_button_checked_success_fill: light-dark(var(--sapContent_IconColor), var(--sapField_SuccessColor));
    --_ui5_radio_button_checked_information_fill: light-dark(var(--sapContent_IconColor), var(--sapField_InformationColor));
    --_ui5_radio_button_warning_error_border_dash: 5;
    --_ui5_radio_button_outer_ring_color: var(--sapField_BorderColor);
    --_ui5_radio_button_outer_ring_width: 2px;
    --_ui5_radio_button_outer_ring_bg: var(--sapField_Background);
    --_ui5_radio_button_outer_ring_hover_color: var(--sapField_Hover_BorderColor);
    --_ui5_radio_button_outer_ring_active_color: var(--sapField_Hover_BorderColor);
    --_ui5_radio_button_outer_ring_checked_hover_color: var(--sapField_Hover_BorderColor);
    --_ui5_radio_button_outer_ring_padding: var(--_ui5-compact-size, 0 .5rem)  var(--_ui5-cozy-size, 0 .6875rem);
    --_ui5_radio_button_outer_ring_padding_with_label: var(--_ui5-compact-size, 0 .5rem)  var(--_ui5-cozy-size, 0 .6875rem);
    --_ui5_radio_button_border_radius: 0;
    --_ui5_radio_button_border: none;
    --_ui5_radio_button_focus_outline: block;
    --_ui5_radio_button_focus_dist: var(--_ui5-compact-size, .1875rem)  var(--_ui5-cozy-size, .375rem);
    --_ui5_radio_button_color: var(--sapField_BorderColor);
    --_ui5_radio_button_label_offset: 1px;
    --_ui5_radio_button_label_color: var(--sapContent_LabelColor);
    --_ui5_radio_button_inner_ring_radius: 27.5%;
    --_ui5_radio_button_read_only_border_type: none;
    --_ui5_radio_button_inner_ring_color: var(--sapContent_Selected_ForegroundColor);
    --_ui5_radio_button_information_border_width: var(--sapField_InformationBorderWidth);
    --_ui5_radio_button_read_only_border_width: var(--sapElement_BorderWidth);
    --_ui5_radio_button_read_only_inner_ring_color: var(--sapField_TextColor);
    --_ui5_rating_indicator_border_radius: .5rem;
    --_ui5_rating_indicator_outline_offset: -.125rem;
    --_ui5_rating_indicator_item_height: var(--_ui5-compact-size, 1em)  var(--_ui5-cozy-size, 1em);
    --_ui5_rating_indicator_item_width: var(--_ui5-compact-size, 1em)  var(--_ui5-cozy-size, 1em);
    --_ui5_rating_indicator_readonly_item_height: var(--_ui5-compact-size, .75em)  var(--_ui5-cozy-size, .75em);
    --_ui5_rating_indicator_readonly_item_width: var(--_ui5-compact-size, .75em)  var(--_ui5-cozy-size, .75em);
    --_ui5_rating_indicator_readonly_item_spacing: .1875rem .1875rem;
    --_ui5_rating_indicator_component_spacing: var(--_ui5-compact-size, .5rem 0)  var(--_ui5-cozy-size, .5rem 0px);
    --_ui5_rating_indicator_component_padding: .25rem;
    --_ui5_rating_indicator_item_size_s: 1.375rem;
    --_ui5_rating_indicator_item_size_l: 2rem;
    --_ui5_segmented_btn_item_border_left: 0px;
    --_ui5_segmented_btn_item_border_right: .0625rem;
    --_ui5_button_focused_border: .125rem dotted var(--sapContent_FocusColor);
    --_ui5_button_focused_border_radius: .375rem;
    --_ui5_button_focused_inner_border_radius: 0;
    --_ui5_button_base_min_width: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.5rem);
    --_ui5_button_base_height: var(--_ui5-compact-size, var(--sapElement_Compact_Height))  var(--_ui5-cozy-size, var(--sapElement_Height));
    --_ui5_button_border_radius: var(--sapButton_BorderCornerRadius);
    --_ui5_button_base_padding: var(--_ui5-compact-size, .4375rem)  var(--_ui5-cozy-size, .6875rem);
    --_ui5_button_base_icon_margin: .563rem;
    --_ui5_button_text_shadow: none;
    --_ui5_button_pressed_focused_border_color: var(--sapContent_ContrastFocusColor);
    --_ui5_button_fontFamily: var(--sapButton_FontFamily);
    --_ui5_button_emphasized_focused_border_color: var(--sapContent_ContrastFocusColor);
    --_ui5_button_emphasized_focused_border_before: .125rem solid var(--sapContent_FocusColor);
    --_ui5_button_emphasized_focused_active_border_color: transparent;
    --_ui5_button_emphasized_border_width: .125rem;
    --_ui5_select_hover_icon_left_border: .0625rem solid var(--sapField_Hover_BorderColor);
    --_ui5_select_label_color: var(--sapField_TextColor);
    --_ui5_select_icon_width: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.25rem);
    --_ui5_select_icon_wrapper_height: 100%;
    --_ui5_split_button_focused_border: .125rem dotted var(--sapContent_FocusColor);
    --_ui5_split_button_focused_border_radius: .375rem;
    --_ui5_split_button_middle_separator_left: -.0625rem;
    --_ui5_split_button_middle_separator_hover_display: block;
    --_ui5_split_button_text_button_right_border_width: 0;
    --_ui5_split_button_transparent_hover_background: var(--sapButton_Hover_Background);
    --_ui5_split_button_host_transparent_hover_background: var(--sapButton_Background);
    --_ui5_split_button_transparent_hover_color: var(--sapButton_TextColor);
    --_ui5_split_button_transparent_disabled_background: var(--sapButton_Background);
    --_ui5_split_button_inner_focused_border_radius_inner: 0;
    --_ui5_split_button_emphasized_separator_color: var(--sapButton_Emphasized_TextColor);
    --_ui5_split_button_positive_separator_color: var(--sapButton_Accept_BorderColor);
    --_ui5_split_button_negative_separator_color: var(--sapButton_Reject_BorderColor);
    --_ui5_split_button_attention_separator_color: var(--sapButton_Attention_BorderColor);
    --_ui5_split_button_attention_separator_color_default: var(--sapButton_Attention_BorderColor);
    --_ui5_split_button_host_default_box_shadow: inset 0 0 0 var(--sapButton_BorderWidth) var(--sapButton_BorderColor);
    --_ui5_split_button_host_attention_box_shadow: inset 0 0 0 var(--sapButton_BorderWidth) var(--sapButton_Attention_BorderColor);
    --_ui5_split_button_host_emphasized_box_shadow: inset 0 0 0 .125rem var(--sapButton_Emphasized_BorderColor);
    --_ui5_split_button_host_positive_box_shadow: inset 0 0 0 var(--sapButton_BorderWidth) var(--sapButton_Accept_BorderColor);
    --_ui5_split_button_host_negative_box_shadow: inset 0 0 0 var(--sapButton_BorderWidth) var(--sapButton_Reject_BorderColor);
    --_ui5_split_button_host_transparent_box_shadow: inset 0 0 0 var(--sapButton_BorderWidth) var(--sapButton_Lite_BorderColor);
    --_ui5_split_button_host_transparent_hover_box_shadow: inset 0 0 0 var(--sapButton_BorderWidth) var(--sapButton_BorderColor);
    --_ui5_split_text_button_border_color: transparent;
    --_ui5_split_text_button_background_color: transparent;
    --_ui5_split_text_button_emphasized_border: .125rem solid var(--sapButton_Emphasized_BorderColor);
    --_ui5_split_text_button_emphasized_border_width: .125rem;
    --_ui5_split_text_button_hover_border: var(--sapButton_BorderWidth) solid var(--sapButton_BorderColor);
    --_ui5_split_text_button_positive_hover_border: var(--sapButton_BorderWidth) solid var(--sapButton_Accept_BorderColor);
    --_ui5_split_text_button_negative_hover_border: var(--sapButton_BorderWidth) solid var(--sapButton_Reject_BorderColor);
    --_ui5_split_text_button_attention_hover_border: var(--sapButton_BorderWidth) solid var(--sapButton_Attention_BorderColor);
    --_ui5_split_text_button_transparent_hover_border: var(--sapButton_BorderWidth) solid var(--sapButton_BorderColor);
    --_ui5_split_arrow_button_hover_border: var(--sapButton_BorderWidth) solid var(--sapButton_BorderColor);
    --_ui5_split_arrow_button_emphasized_hover_border: .0625rem solid var(--sapButton_Emphasized_BorderColor);
    --_ui5_split_arrow_button_positive_hover_border: var(--sapButton_BorderWidth) solid var(--sapButton_Accept_BorderColor);
    --_ui5_split_arrow_button_negative_hover_border: var(--sapButton_BorderWidth) solid var(--sapButton_Reject_BorderColor);
    --_ui5_split_arrow_button_attention_hover_border: var(--sapButton_BorderWidth) solid var(--sapButton_Attention_BorderColor);
    --_ui5_split_arrow_button_transparent_hover_border: var(--sapButton_BorderWidth) solid var(--sapButton_BorderColor);
    --_ui5_split_text_button_hover_border_right: none;
    --_ui5_split_text_button_positive_hover_border_right: none;
    --_ui5_split_text_button_negative_hover_border_right: none;
    --_ui5_split_text_button_attention_hover_border_right: none;
    --_ui5_split_text_button_transparent_hover_border_right: none;
    --_ui5_split_button_middle_separator_hover_display_emphasized: none;
    --_ui5_split_arrow_button_emphasized_hover_box_shadow: inset 0 -.0625rem 0 var(--sapButton_BorderColor), inset -.0625rem 0 0 var(--sapButton_BorderColor), inset 0 .0625rem 0 var(--sapButton_BorderColor);
    --_ui5_split_arrow_button_emphasized_hover_box_shadow_rtl: inset 0 -.0625rem 0 var(--sapButton_BorderColor), inset .0625rem 0 0 var(--sapButton_BorderColor), inset 0 .0625rem 0 var(--sapButton_BorderColor);
    --_ui5_switch_height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_switch_width: var(--_ui5-compact-size, 2.75rem)  var(--_ui5-cozy-size, 2.5rem);
    --_ui5_switch_min_width: var(--_ui5-compact-size, none)  var(--_ui5-cozy-size, none);
    --_ui5_switch_with_label_width: var(--_ui5-compact-size, 2.75rem)  var(--_ui5-cozy-size, 2.875rem);
    --_ui5_switch_focus_outline: none;
    --_ui5_switch_root_outline_top: var(--_ui5-compact-size, .25rem)  var(--_ui5-cozy-size, .5rem);
    --_ui5_switch_root_outline_bottom: var(--_ui5-compact-size, .25rem)  var(--_ui5-cozy-size, .5rem);
    --_ui5_switch_root_outline_left: -.125rem;
    --_ui5_switch_root_outline_right: -.125rem;
    --_ui5_switch_foucs_border_size: 1px;
    --_ui5-switch-root-border-radius: 0;
    --_ui5-switch-root-box-shadow: none;
    --_ui5_switch_root_after_outline: .125rem solid var(--sapContent_FocusColor);
    --_ui5_switch_disabled_opacity: var(--sapContent_DisabledOpacity);
    --_ui5_switch_transform: var(--_ui5-compact-size, translateX(100%) translateX(-1.375rem))  var(--_ui5-cozy-size, translateX(100%) translateX(-1.625rem));
    --_ui5_switch_transform_with_label: var(--_ui5-compact-size, translateX(100%) translateX(-1.875rem))  var(--_ui5-cozy-size, translateX(100%) translateX(-1.875rem));
    --_ui5_switch_rtl_transform: var(--_ui5-compact-size, translateX(1.375rem) translateX(-100%))  var(--_ui5-cozy-size, translateX(-100%) translateX(1.625rem));
    --_ui5_switch_rtl_transform_with_label: var(--_ui5-compact-size, translateX(1.875rem) translateX(-100%))  var(--_ui5-cozy-size, translateX(-100%) translateX(1.875rem));
    --_ui5_switch_track_with_label_width: var(--_ui5-compact-size, 2.75rem)  var(--_ui5-cozy-size, 2.875rem);
    --_ui5_switch_track_with_label_height: var(--_ui5-compact-size, 1.25rem)  var(--_ui5-cozy-size, 1.5rem);
    --_ui5_switch_track_width: var(--_ui5-compact-size, 2.75rem)  var(--_ui5-cozy-size, 2.5rem);
    --_ui5_switch_track_height: var(--_ui5-compact-size, 1.25rem)  var(--_ui5-cozy-size, 1.5rem);
    --_ui5_switch_track_border_radius: .75rem;
    --_ui5-switch-track-border: 1px solid;
    --_ui5_switch_track_active_background_color: var(--sapButton_Track_Selected_Background);
    --_ui5_switch_track_inactive_background_color: var(--sapButton_Track_Background);
    --_ui5_switch_track_hover_active_background_color: var(--sapButton_Track_Selected_Hover_Background);
    --_ui5_switch_track_hover_inactive_background_color: var(--sapButton_Track_Hover_Background);
    --_ui5_switch_track_active_border_color: var(--sapButton_Track_Selected_BorderColor);
    --_ui5_switch_track_inactive_border_color: var(--sapButton_Track_BorderColor);
    --_ui5_switch_track_hover_active_border_color: var(--sapButton_Track_Selected_Hover_BorderColor);
    --_ui5_switch_track_hover_inactive_border_color: var(--sapButton_Track_Hover_BorderColor);
    --_ui5_switch_track_semantic_accept_background_color: var(--sapButton_Track_Positive_Background);
    --_ui5_switch_track_semantic_reject_background_color: var(--sapButton_Track_Negative_Background);
    --_ui5_switch_track_semantic_hover_accept_background_color: var(--sapButton_Track_Positive_Hover_Background);
    --_ui5_switch_track_semantic_hover_reject_background_color: var(--sapButton_Track_Negative_Hover_Background);
    --_ui5_switch_track_semantic_accept_border_color: var(--sapButton_Track_Positive_BorderColor);
    --_ui5_switch_track_semantic_reject_border_color: var(--sapButton_Track_Negative_BorderColor);
    --_ui5_switch_track_semantic_hover_accept_border_color: var(--sapButton_Track_Positive_Hover_BorderColor);
    --_ui5_switch_track_semantic_hover_reject_border_color: var(--sapButton_Track_Negative_Hover_BorderColor);
    --_ui5_switch_track_transition: none;
    --_ui5_switch_track_icon_display: inline-block;
    --_ui5_switch_handle_width: var(--_ui5-compact-size, 1.25rem)  var(--_ui5-cozy-size, 1.5rem);
    --_ui5_switch_handle_height: var(--_ui5-compact-size, 1rem)  var(--_ui5-cozy-size, 1.25rem);
    --_ui5_switch_handle_with_label_width: var(--_ui5-compact-size, 1.75rem)  var(--_ui5-cozy-size, 1.75rem);
    --_ui5_switch_handle_with_label_height: var(--_ui5-compact-size, 1rem)  var(--_ui5-cozy-size, 1.25rem);
    --_ui5_switch_handle_border: var(--_ui5_switch_handle_border_width) solid var(--sapButton_Handle_BorderColor);
    --_ui5_switch_handle_border_width: .125rem;
    --_ui5_switch_handle_border_radius: 1rem;
    --_ui5_switch_handle_active_background_color: var(--sapButton_Handle_Selected_Background);
    --_ui5_switch_handle_inactive_background_color: var(--sapButton_Handle_Background);
    --_ui5_switch_handle_hover_active_background_color: var(--sapButton_Handle_Selected_Hover_Background);
    --_ui5_switch_handle_hover_inactive_background_color: var(--sapButton_Handle_Hover_Background);
    --_ui5_switch_handle_active_border_color: var(--sapButton_Handle_Selected_BorderColor);
    --_ui5_switch_handle_inactive_border_color: var(--sapButton_Handle_BorderColor);
    --_ui5_switch_handle_hover_active_border_color: var(--sapButton_Handle_Selected_BorderColor);
    --_ui5_switch_handle_hover_inactive_border_color: var(--sapButton_Handle_BorderColor);
    --_ui5_switch_handle_semantic_accept_background_color: var(--sapButton_Handle_Positive_Background);
    --_ui5_switch_handle_semantic_reject_background_color: var(--sapButton_Handle_Negative_Background);
    --_ui5_switch_handle_semantic_hover_accept_background_color: var(--sapButton_Handle_Positive_Hover_Background);
    --_ui5_switch_handle_semantic_hover_reject_background_color: var(--sapButton_Handle_Negative_Hover_Background);
    --_ui5_switch_handle_semantic_accept_border_color: var(--sapButton_Handle_Positive_BorderColor);
    --_ui5_switch_handle_semantic_reject_border_color: var(--sapButton_Handle_Negative_BorderColor);
    --_ui5_switch_handle_semantic_hover_accept_border_color: var(--sapButton_Handle_Positive_BorderColor);
    --_ui5_switch_handle_semantic_hover_reject_border_color: var(--sapButton_Handle_Negative_BorderColor);
    --_ui5_switch_handle_on_hover_box_shadow: 0 0 0 .125rem var(--sapButton_Handle_Selected_Hover_BorderColor);
    --_ui5_switch_handle_off_hover_box_shadow: 0 0 0 .125rem var(--sapButton_Handle_Hover_BorderColor);
    --_ui5_switch_handle_semantic_on_hover_box_shadow: 0 0 0 .125rem var(--sapButton_Handle_Positive_Hover_BorderColor);
    --_ui5_switch_handle_semantic_off_hover_box_shadow: 0 0 0 .125rem var(--sapButton_Handle_Negative_Hover_BorderColor);
    --_ui5_switch_handle_left: .0625rem;
    --_ui5-switch-slider-texts-display: inline;
    --_ui5_switch_text_font_family: var(--sapContent_IconFontFamily);
    --_ui5_switch_text_font_size: var(--_ui5-compact-size, var(--sapFontSize))  var(--_ui5-cozy-size, var(--sapFontLargeSize));
    --_ui5_switch_text_with_label_font_family: "72-Condensed-Bold", "72", "72full", Arial, Helvetica, sans-serif;
    --_ui5_switch_text_with_label_font_size: var(--sapFontSmallSize);
    --_ui5_switch_text_with_label_width: 1.75rem;
    --_ui5_switch_text_width: var(--_ui5-compact-size, 1rem)  var(--_ui5-cozy-size, 1.25rem);
    --_ui5_switch_text_inactive_left: .1875rem;
    --_ui5_switch_text_inactive_left_alternate: .0625rem;
    --_ui5_switch_text_inactive_right: auto;
    --_ui5_switch_text_inactive_right_alternate: .125rem;
    --_ui5_switch_text_active_left: var(--_ui5-compact-size, .1875rem)  var(--_ui5-cozy-size, .1875rem);
    --_ui5_switch_text_active_left_alternate: var(--_ui5-compact-size, .0625rem)  var(--_ui5-cozy-size, .0625rem);
    --_ui5_switch_text_active_color: var(--sapButton_Handle_Selected_TextColor);
    --_ui5_switch_text_inactive_color: var(--sapButton_Handle_TextColor);
    --_ui5_switch_text_semantic_accept_color: var(--sapButton_Handle_Positive_TextColor);
    --_ui5_switch_text_semantic_reject_color: var(--sapButton_Handle_Negative_TextColor);
    --_ui5_switch_text_overflow: hidden;
    --_ui5_switch_text_z_index: 1;
    --_ui5_switch_text_hidden: hidden;
    --_ui5_switch_text_min_width: none;
    --_ui5_switch_icon_width: 1rem;
    --_ui5_switch_icon_height: 1rem;
    --_ui5_switch_readonly_track_border_style: solid;
    --_ui5_switch_readonly_handle_border_style: solid;
    --_ui5_switch_root_after_boreder_radius: 1rem;
    --_ui5_tc_header_height: var(--_ui5-compact-size, var(--_ui5_tc_item_height))  var(--_ui5-cozy-size, var(--_ui5_tc_item_height));
    --_ui5_tc_header_height_text_only: var(--_ui5_tc_item_text_only_height);
    --_ui5_tc_header_height_text_with_additional_text: var(--_ui5_tc_item_text_only_with_additional_text_height);
    --_ui5_tc_header_box_shadow: var(--sapContent_HeaderShadow);
    --_ui5_tc_header_border_bottom: .125rem solid var(--sapPageHeader_BorderColor);
    --_ui5_tc_header_background: var(--sapObjectHeader_Background);
    --_ui5_tc_header_background_translucent: var(--sapObjectHeader_Background);
    --_ui5_tc_content_background: var(--sapBackgroundColor);
    --_ui5_tc_content_background_translucent: var(--sapGroup_ContentBackground);
    --_ui5_tc_headeritem_padding: 1rem;
    --_ui5_tc_headerItem_color: var(--sapTab_TextColor);
    --_ui5_tc_headerItem_additional_text_color: var(--sapContent_LabelColor);
    --_ui5_tc_headerItem_text_hover_color: var(--sapTab_Selected_TextColor);
    --_ui5_tc_headerItem_text_selected_color: var(--sapTab_Selected_TextColor);
    --_ui5_tc_headerItem_text_selected_hover_color: var(--sapPageHeader_BorderColor);
    --_ui5_tc_headeritem_text_font_weight: normal;
    --_ui5_tc_headerItem_additional_text_font_weight: normal;
    --_ui5_tc_headerItem_neutral_border_color: var(--sapTab_Neutral_ForegroundColor);
    --_ui5_tc_headerItem_transition: none;
    --_ui5_tc_headerItemContent_border_radius: .125rem .125rem 0 0;
    --_ui5_tc_headerItemContent_border_bg: transparent;
    --_ui5_tc_headerItem_neutral_border_bg: transparent;
    --_ui5_tc_headerItem_positive_border_bg: transparent;
    --_ui5_tc_headerItem_negative_border_bg: transparent;
    --_ui5_tc_headerItem_critical_border_bg: transparent;
    --_ui5_tc_headerItemContent_border_height: 0;
    --_ui5_tc_headerItem_focus_border: .125rem dotted var(--sapContent_FocusColor);
    --_ui5_tc_headerItem_text_focus_border_offset_left: 0px;
    --_ui5_tc_headerItem_text_focus_border_offset_right: 0px;
    --_ui5_tc_headerItem_text_focus_border_offset_top: 0px;
    --_ui5_tc_headerItem_text_focus_border_offset_bottom: 0px;
    --_ui5_tc_headerItem_mixed_mode_focus_border_offset_left: .75rem;
    --_ui5_tc_headerItem_mixed_mode_focus_border_offset_right: .625rem;
    --_ui5_tc_headerItem_mixed_mode_focus_border_offset_top: .75rem;
    --_ui5_tc_headerItem_mixed_mode_focus_border_offset_bottom: .75rem;
    --_ui5_tc_headerItemContent_default_focus_border: none;
    --_ui5_tc_headerItemContent_focus_border_radius: 0;
    --_ui5_tc_headerItemSemanticIcon_display: inline-block;
    --_ui5_tc_headerItemSemanticIcon_size: .75rem;
    --_ui5_tc_headerItem_focus_border_radius: 0px;
    --_ui5_tc_mixedMode_itemText_color: var(--sapContent_LabelColor);
    --_ui5_tc_mixedMode_itemText_font_family: var(--sapFontFamily);
    --_ui5_tc_mixedMode_itemText_font_size: var(--sapFontSmallSize);
    --_ui5_tc_mixedMode_itemText_font_weight: normal;
    --_ui5_tc_headerItem_expand_button_margin_inline_start: 0rem;
    --_ui5_tc_headerItem_single_click_expand_button_margin_inline_start: .25rem;
    --_ui5_tc_headerItem_expand_button_border_radius: .25rem;
    --_ui5_tc_headerItem_expand_button_separator_display: none;
    --_ui5_tc_overflowItem_positive_color: var(--sapTextColor);
    --_ui5_tc_overflowItem_negative_color: var(--sapTextColor);
    --_ui5_tc_overflowItem_critical_color: var(--sapTextColor);
    --_ui5_tc_overflowItem_focus_offset: .125rem;
    --_ui5_tc_overflowItem_indent: .5rem;
    --_ui5_tc_overflowItem_extra_indent: 1rem;
    --_ui5_tc_headerItemIcon_border: .125rem solid var(--sapTab_ForegroundColor);
    --_ui5_tc_headerItemIcon_semantic_selected_color: var(--sapGroup_ContentBackground);
    --_ui5_tc_overflowItem_default_color: var(--sapTextColor);
    --_ui5_tc_overflowItem_current_color: var(--_ui5_tc_overflowItem_default_color);
    --_ui5_tc_content_border_bottom: .125rem solid var(--sapObjectHeader_BorderColor);
    --_ui5_tc_headerItem_focus_border_offset: -2px;
    --_ui5_tc_headerItemIcon_focus_border_radius: 0;
    --_ui5_tc_overflow_text_color: var(--sapTextColor);
    --_ui5_tc_overflowItem_additional: 1;
    --_ui5_table_cell_valign: center;
    --_ui5_table_cell_min_width: 2.75rem;
    --_ui5_table_navigated_cell_width: .25rem;
    --_ui5_first_table_cell_horizontal_padding: 1rem;
    --_ui5_table_cell_horizontal_padding: .5rem;
    --_ui5_table_cell_vertical_padding: .25rem;
    --_ui5_table_row_actions_gap: .25rem;
    --_ui5_table_row_alternating_background: var(--sapTableRow_AlternatingBackground, var(--sapList_AlternatingBackground));
    --_ui5_table_row_alternating_hover_background: var(--sapTableRow_AlternatingHoverBackground, var(--sapList_Hover_Background));
    --_ui5_table_row_alternating_selection_background: var(--sapTableRow_AlternatingSelectionBackground, var(--sapList_SelectionBackgroundColor));
    --_ui5_table_row_alternating_selection_hover_background: var(--sapTableRow_AlternatingSelectionHoverBackground, var(--sapList_Hover_SelectionBackground));
    --_ui5-toolbar-padding-left: .5rem;
    --_ui5-toolbar-padding-right: .5rem;
    --_ui5-toolbar-item-margin-left: 0;
    --_ui5-toolbar-item-margin-right: .25rem;
    --_ui5_load_more_padding: .25rem;
    --_ui5_load_more_border: 1px solid var(--sapButton_BorderColor);
    --_ui5_load_more_border_radius: .375rem;
    --_ui5_load_more_outline_width: .125rem;
    --_ui5_text_max_lines: initial;
    --_ui5_textarea_state_border_width: .125rem;
    --_ui5_textarea_information_border_width: var(--sapField_InformationBorderWidth);
    --_ui5_textarea_placeholder_font_style: normal;
    --_ui5_textarea_value_state_error_warning_placeholder_font_weight: bold;
    --_ui5_textarea_error_placeholder_font_style: normal;
    --_ui5_textarea_error_placeholder_color: var(--sapField_TextColor);
    --_ui5_textarea_error_hover_background_color: var(--sapField_InvalidBackground);
    --_ui5_textarea_hover_border: var(--sapField_BorderWidth) var(--sapField_BorderStyle) var(--sapField_Hover_BorderColor);
    --_ui5_textarea_error_warning_border_style: dashed;
    --_ui5_textarea_disabled_opacity: .4;
    --_ui5_textarea_line_height: 1.5;
    --_ui5_textarea_focus_pseudo_element_content: "";
    --_ui5_textarea_focused_value_state_error_background: var(--sapField_InvalidBackground);
    --_ui5_textarea_focused_value_state_warning_background: var(--sapField_WarningBackground);
    --_ui5_textarea_focused_value_state_success_background: var(--sapField_SuccessBackground);
    --_ui5_textarea_focused_value_state_information_background: var(--sapField_InformationBackground);
    --_ui5_textarea_focused_value_state_error_focus_outline_color: var(--sapContent_FocusColor);
    --_ui5_textarea_focused_value_state_warning_focus_outline_color: var(--sapContent_FocusColor);
    --_ui5_textarea_focused_value_state_success_focus_outline_color: var(--sapContent_FocusColor);
    --_ui5_textarea_focus_offset: 1px;
    --_ui5_textarea_readonly_focus_offset: 1px;
    --_ui5_textarea_value_state_focus_offset: 1px;
    --_ui5_textarea_focus_outline_color: var(--sapContent_FocusColor);
    --_ui5_textarea_min_height: var(--_ui5-compact-size, 1.625rem)  var(--_ui5-cozy-size, 2.25rem);
    --_ui5_textarea_wrapper_padding: .0625rem;
    --_ui5_textarea_success_wrapper_padding: 0;
    --_ui5_textarea_warning_error_wrapper_padding: 0;
    --_ui5_textarea_information_wrapper_padding: 0;
    --_ui5_textarea_inner_width: 100%;
    --_ui5_textarea_padding_right_and_left: var(--_ui5-compact-size, .375rem)  var(--_ui5-cozy-size, .5rem);
    --_ui5_textarea_padding_right_and_left_error_warning: var(--_ui5-compact-size, .375rem)  var(--_ui5-cozy-size, .5rem);
    --_ui5_textarea_padding_right_and_left_information: var(--_ui5-compact-size, .4375rem)  var(--_ui5-cozy-size, .5625rem);
    --_ui5_textarea_padding_right_and_left_readonly: var(--_ui5-compact-size, .375rem)  var(--_ui5-cozy-size, .5rem);
    --_ui5_textarea_padding_top: var(--_ui5-compact-size, .0625rem)  var(--_ui5-cozy-size, .375rem);
    --_ui5_textarea_padding_bottom: var(--_ui5-compact-size, 0rem)  var(--_ui5-cozy-size, .3125rem);
    --_ui5_textarea_padding_top_readonly: var(--_ui5-compact-size, .0625rem)  var(--_ui5-cozy-size, .375rem);
    --_ui5_textarea_padding_bottom_readonly: var(--_ui5-compact-size, 0rem)  var(--_ui5-cozy-size, .3125rem);
    --_ui5_textarea_padding_top_error_warning: var(--_ui5-compact-size, .0625rem)  var(--_ui5-cozy-size, .375rem);
    --_ui5_textarea_padding_bottom_error_warning: var(--_ui5-compact-size, 0rem)  var(--_ui5-cozy-size, .3125rem);
    --_ui5_textarea_padding_top_information: var(--_ui5-compact-size, .125rem)  var(--_ui5-cozy-size, .4375rem);
    --_ui5_textarea_padding_bottom_information: var(--_ui5-compact-size, .0625rem)  var(--_ui5-cozy-size, .375rem);
    --_ui5_textarea_margin: var(--_ui5-compact-size, .1875rem 0)  var(--_ui5-cozy-size, .25rem 0);
    --_ui5_textarea_readonly_border_style: var(--sapField_BorderStyle);
    --_ui5_textarea_error_warning_font_weight: bold;
    --_ui5_textarea_error_warning_font_style: italic;
    --_ui5-time_picker_border_radius: 0;
    --_ui5_toast_vertical_offset: 3rem;
    --_ui5_toast_horizontal_offset: 2rem;
    --_ui5_toast_background: var(--sapIndicationColor_9_Background);
    --_ui5_toast_shadow: var(--sapContent_Lite_Shadow);
    --_ui5_toast_offset_width: -.1875rem;
    --_ui5_toggle_button_emphasized_text_shadow: none;
    --_ui5_yearpicker_item_margin: .0625rem;
    --_ui5_yearpicker_item_border: .0625rem solid var(--sapButton_Lite_BorderColor);
    --_ui5_yearpicker_item_border_radius: .5rem;
    --_ui5_yearpicker_item_hover_border: .0625rem solid var(--sapButton_Lite_Hover_BorderColor);
    --_ui5_yearpicker_item_selected_border: .0625rem solid var(--sapButton_Selected_BorderColor);
    --_ui5_yearpicker_item_selected_hover_border: .0625rem solid var(--sapButton_Selected_Hover_BorderColor);
    --_ui5_token_background: var(--sapButton_TokenBackground);
    --_ui5_token_readonly_background: var(--sapField_ReadOnly_Background);
    --_ui5_token_readonly_color: var(--sapContent_LabelColor);
    --_ui5_token_border_radius: .25rem;
    --_ui5_token_focus_outline_width: .125rem;
    --_ui5_token_outline_offset: var(--_ui5-compact-size, -.125rem)  var(--_ui5-cozy-size, -.125rem);
    --_ui5_token_text_color: var(--sapTextColor);
    --_ui5_token_right_margin: var(--_ui5-compact-size, .25rem)  var(--_ui5-cozy-size, .3125rem);
    --_ui5_token_left_padding: var(--_ui5-compact-size, .25rem)  var(--_ui5-cozy-size, .3125rem);
    --_ui5_token_readonly_padding: var(--_ui5-compact-size, .125rem .25rem)  var(--_ui5-cozy-size, .25rem .3125rem);
    --_ui5_token_selected_focus_outline: var(--_ui5_token_focus_outline_width) dotted var(--sapContent_ContrastFocusColor);
    --_ui5_token_focus_outline: var(--_ui5_token_focus_outline_width) dotted var(--sapContent_FocusColor);
    --_ui5_token_focused_selected_border: 1px solid var(--sapButton_Selected_BorderColor);
    --ui5_token_focus_pseudo_element_content: none;
    --_ui5_token_focus_offset: var(--_ui5-compact-size, -.125rem)  var(--_ui5-cozy-size, 0);
    --_ui5_token_selected_text_font_family: var(--sapFontFamily);
    --_ui5_token_selected_internal_border_bottom: none;
    --_ui5_token_selected_internal_border_bottom_radius: 0;
    --_ui5_token_focus_outline_border_radius: .25rem;
    --_ui5_tokenizer_padding: var(--_ui5-compact-size, .25rem)  var(--_ui5-cozy-size, .3125rem);
    --_ui5_tokenizer_gap: var(--_ui5-compact-size, .375em .25rem)  var(--_ui5-cozy-size, .625rem .25rem);
    --_ui5_tokenizer_n_more_text_color: var(--sapField_TextColor);
    --_ui5_tokenizer-popover_offset: var(--_ui5-compact-size, .1875rem)  var(--_ui5-cozy-size, .3125rem);
    --_ui5_value_state_message_border: var(--sapField_BorderWidth) solid var(--sapField_BorderColor);
    --_ui5_value_state_header_border: none;
    --_ui5_input_value_state_icon_display: inline-block;
    --_ui5_value_state_message_padding: .5rem .5rem .5rem 1.875rem;
    --_ui5_value_state_message_padding_phone: .5rem .5rem .5rem 2.375rem;
    --_ui5_value_state_header_padding: .5rem .5rem .5rem 1.875rem;
    --_ui5_value_state_message_popover_box_shadow: none;
    --_ui5_value_state_message_icon_width: 1rem;
    --_ui5_value_state_message_icon_height: 1rem;
    --_ui5_input_value_state_icon_offset: .625rem;
    --_ui5_value_state_header_offset: -.1875rem;
    --_ui5_value_state_message_popover_border_radius: 0;
    --_ui5_value_state_header_box_shadow_error: inset 0 -.125rem var(--sapField_InvalidColor);
    --_ui5_value_state_header_box_shadow_information: inset 0 -.125rem var(--sapField_InformationColor);
    --_ui5_value_state_header_box_shadow_success: inset 0 -.125rem var(--sapField_SuccessColor);
    --_ui5_value_state_header_box_shadow_warning: inset 0 -.125rem var(--sapField_WarningColor);
    --_ui5_value_state_message_line_height: 1.125rem;
    --_ui5_value_state_message_popover_header_min_height: 2rem;
    --_ui5_value_state_message_popover_header_min_width: 6rem;
    --_ui5_value_state_message_popover_header_max_width: 22rem;
    --_ui5_value_state_message_popover_header_width: auto;
    --_ui5_value_state_message_icon_offset_phone: 1rem;
    --_ui5_value_state_header_border_bottom: none;
    --_ui5_slider_inner_min_width: 4rem;
    --_ui5_slider_progress_border_width: .0625rem;
    --_ui5_slider_disabled_opacity: .4;
    --_ui5_slider_active_progress_left: -.0625rem;
    --_ui5_slider_handle_height: var(--_ui5-compact-size, 1.25rem)  var(--_ui5-cozy-size, 1.5rem);
    --_ui5_slider_handle_width: var(--_ui5-compact-size, 1.5rem)  var(--_ui5-cozy-size, 2rem);
    --_ui5_slider_handle_focus_border: .125rem solid var(--sapContent_FocusColor);
    --ui5_slider_handle_outline: var(--sapContent_FocusWidth) var(--sapContent_FocusStyle) var(--sapContent_FocusColor);
    --ui5_slider_handle_outline_offset: .0625rem;
    --_ui5_slider_handle_background: var(--sapSlider_HandleBackground);
    --_ui5_slider_handle_border: .0625rem solid var(--sapSlider_HandleBorderColor);
    --_ui5_slider_handle_border_radius: .5rem;
    --_ui5_slider_handle_hover_background: var(--sapSlider_Hover_HandleBackground);
    --_ui5_slider_handle_hover_border: .0625rem solid var(--sapSlider_Hover_HandleBorderColor);
    --_ui5_slider_handle_background_focus: var(--sapSlider_Active_RangeHandleBackground);
    --_ui5_slider_handle_active_border: .125rem solid var(--sapSlider_Active_HandleBorderColor);
    --_ui5_slider_handle_icon_display: inline-block;
    --_ui5_slider_handle_icon_size: .875rem;
    --_ui5_slider_handle_box_sizing: border-box;
    --_ui5_slider_scale_background: var(--sapSlider_Background);
    --_ui5_slider_scale_progress_background: var(--sapSlider_Selected_Background);
    --_ui5_slider_scale_progress_border: 1px solid var(--sapSlider_Selected_BorderColor);
    --_ui5_slider_scale_dots_distance: var(--_ui5-compact-size, -.75rem)  var(--_ui5-cozy-size, -1rem);
    --_ui5_slider_scale_dots_display: inline-block;
    --_ui5_slider_scale_tickmark_height: .5rem;
    --_ui5_slider_scale_root_box_sizing: content-box;
    --_ui5_slider_scale_progress_top: -1px;
    --_ui5_slider_scale_progress_height: .375rem;
    --_ui5_range_slider_progress_focus_display: block;
    --_ui5_range_slider_progress_focus_top: calc(-1 * ((var(--_ui5_slider_handle_height) / 2) + .1875rem) + 2 * var(--_ui5_slider_progress_border_width) - .125rem);
    --_ui5_range_slider_progress_focus_left: calc(-1 * ((var(--_ui5_slider_handle_width) / 2) + .1875rem + var(--_ui5_slider_progress_border_width)) - .125rem);
    --_ui5_range_slider_progress_focus_right: calc(-1 * ((var(--_ui5_slider_handle_width) / 2) + .1875rem + var(--_ui5_slider_progress_border_width)) - .125rem - .0625rem);
    --_ui5_range_slider_progress_focus_height: calc(var(--_ui5_slider_handle_height) + .375rem + .25rem + .0625rem);
    --_ui5_range_slider_progress_focus_padding: 0 1rem 0 1rem;
    --_ui5_range_slider_progress_focus_border: var(--sapContent_FocusWidth) var(--sapContent_FocusStyle) var(--sapContent_FocusColor);
    --_ui5_range_slider_progress_focus_border_radius: .5rem;
    --_ui5_range_slider_legacy_progress_focus_display: none;
    --_ui5_range_slider_focus_outline_width: 100%;
    --_ui5_slider_progress_outline: .0625rem var(--sapContent_FocusStyle) var(--sapContent_FocusColor);
    --_ui5_range_slider_focus_outline_radius: 0;
    --_ui5_slider_progress_outline_offset: var(--_ui5-compact-size, -.625rem)  var(--_ui5-cozy-size, -.8125rem);
    --_ui5_slider_outer_height: var(--_ui5-compact-size, 1.3125rem)  var(--_ui5-cozy-size, 1.6875rem);
    --_ui5_slider_progress_outline_offset_left: 0;
    --_ui5_slider_scale_progress_border_radius: .25rem;
    --_ui5_slider_scale_border: 1px solid var(--sapSlider_Selected_BorderColor);
    --_ui5_step_input_input_error_background_color: var(--sapField_InvalidBackground);
    --_ui5-step_input_button_state_hover_background_color: var(--sapField_Background);
    --_ui5_step_input_border_style: 1px solid var(--sapField_BorderColor);
    --_ui5_step_input_border_style_hover: 1px solid var(--sapField_Hover_BorderColor);
    --_ui5_step_input_button_background_color: var(--sapField_Background);
    --_ui5_step_input_input_border: 1px solid transparent;
    --_ui5_step_input_input_margin_top: -.0625rem;
    --_ui5_step_input_button_display: inline-block;
    --_ui5_step_input_button_left: 0;
    --_ui5_step_input_button_right: 0;
    --_ui5_step_input_input_border_focused_after: var(--_ui5_input_focus_border_width) dotted var(--sapContent_FocusColor);
    --_ui5_step_input_input_border_top_bottom_focused_after: .0625rem;
    --_ui5_step_input_input_border_radius_focused_after: 0;
    --_ui5_step_input_input_information_border_color_focused_after: var(--sapField_BorderColor);
    --_ui5_step_input_input_warning_border_color_focused_after: var(--sapField_BorderColor);
    --_ui5_step_input_input_success_border_color_focused_after: var(--sapField_BorderColor);
    --_ui5_step_input_input_error_border_color_focused_after: var(--sapField_BorderColor);
    --_ui5_step_input_disabled_button_background: var(--sapField_ReadOnly_Background);
    --_ui5_step_input_border_color_hover: var(--sapField_Hover_Background);
    --_ui5_step_input_border_hover: 1px solid var(--sapField_Hover_BorderColor);
    --_ui5_input_input_background_color: var(--sapField_InvalidBackground);
    --_ui5_step_input_min_width: var(--_ui5-compact-size, 6rem)  var(--_ui5-cozy-size, 7.25rem);
    --_ui5_step_input_padding: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.5rem);
    --_ui5_calendar_height: var(--_ui5-compact-size, 18rem)  var(--_ui5-cozy-size, 24.5rem);
    --_ui5_calendar_width: var(--_ui5-compact-size, 17.75rem)  var(--_ui5-cozy-size, 20rem);
    --_ui5_calendar_left_right_padding: var(--_ui5-compact-size, .25rem)  var(--_ui5-cozy-size, .5rem);
    --_ui5_calendar_top_bottom_padding: var(--_ui5-compact-size, .5rem)  var(--_ui5-cozy-size, 1rem);
    --_ui5_calendar_header_height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 3rem);
    --_ui5_calendar_header_arrow_button_width: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.5rem);
    --_ui5_calendar_header_padding: var(--_ui5-compact-size, 0)  var(--_ui5-cozy-size, .25rem 0);
    --_ui5_calendar_multiple_layout: var(--_ui5-compact-size, column)  var(--_ui5-cozy-size, row);
    --_ui5_calendar_multiple_gap: var(--_ui5-compact-size, .5rem)  var(--_ui5-cozy-size, 1rem);
    --_ui5_calendar_multiple_width: var(--_ui5-compact-size, var(--_ui5_calendar_width))  var(--_ui5-cozy-size, calc((var(--_ui5_calendar_width) * 2) + (var(--_ui5_calendar_left_right_padding) * 2)));
    --_ui5_calendar_overlay_top: var(--_ui5-compact-size, 54%)  var(--_ui5-cozy-size, 57%);
    --_ui5_calendar_overlay_width: var(--_ui5-compact-size, 100%)  var(--_ui5-cozy-size, 16rem);
    --_ui5_checkbox_root_side_padding: var(--_ui5-compact-size, var(--_ui5_checkbox_wrapped_focus_padding))  var(--_ui5-cozy-size, .6875rem);
    --_ui5_checkbox_partially_icon_size: var(--_ui5-compact-size, .5rem)  var(--_ui5-cozy-size, .75rem);
    --_ui5_custom_list_item_rb_min_width: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_day_picker_item_width: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.25rem);
    --_ui5_day_picker_item_height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.875rem);
    --_ui5_day_picker_empty_height: var(--_ui5-compact-size, 2.125rem)  var(--_ui5-cozy-size, 3rem);
    --_ui5_day_picker_item_justify_content: var(--_ui5-compact-size, flex-end)  var(--_ui5-cozy-size, space-between);
    --_ui5_dp_item_withsecondtype_font_size: var(--_ui5-compact-size, var(--sapFontSmallSize))  var(--_ui5-cozy-size, var(--sapFontSize));
    --_ui5_daypicker_item_now_selected_two_calendar_focus_special_day_top: var(--_ui5-compact-size, 1.125rem)  var(--_ui5-cozy-size, 2rem);
    --_ui5_daypicker_item_now_selected_two_calendar_focus_special_day_right: var(--_ui5-compact-size, 1.125rem)  var(--_ui5-cozy-size, 1.4375rem);
    --_ui5_dp_two_calendar_item_secondary_text_height: var(--_ui5-compact-size, .75rem)  var(--_ui5-cozy-size, 1rem);
    --_ui5_dp_two_calendar_item_text_padding_top: var(--_ui5-compact-size, .5rem)  var(--_ui5-cozy-size, .4375rem);
    --_ui5_dp_two_calendar_item_secondary_text_padding_block: var(--_ui5-compact-size, 0 .625rem)  var(--_ui5-cozy-size, 0 .5rem);
    --_ui5_dp_two_calendar_item_secondary_text_padding: var(--_ui5-compact-size, 0 .375rem)  var(--_ui5-cozy-size, 0 .5rem);
    --_ui5_daypicker_item_now_selected_two_calendar_focus_secondary_text_padding_block: var(--_ui5-compact-size, 0 1rem)  var(--_ui5-cozy-size, 0 .5rem);
    --_ui5_daypicker_two_calendar_item_selected_focus_margin_bottom: var(--_ui5-compact-size, -.25rem)  var(--_ui5-cozy-size, 0);
    --_ui5_daypicker_two_calendar_item_selected_focus_padding_right: var(--_ui5-compact-size, .4375rem)  var(--_ui5-cozy-size, .4375rem);
    --_ui5_calendar_multiple_months_height: var(--_ui5-compact-size, calc(2 * var(--_ui5_calendar_height)))  var(--_ui5-cozy-size, var(--_ui5_calendar_height));
    --_ui5-calendar-legend-item-root-focus-offset: -.125rem;
    --_ui5-calendar-legend-item-box-inner-margin: .5rem;
    --_ui5_color_picker_slider_progress_container_height: var(--_ui5-compact-size, 1.125rem)  var(--_ui5-cozy-size, 1.625rem);
    --_ui5_color_picker_slider_container_margin_top: var(--_ui5-compact-size, -.375rem)  var(--_ui5-cozy-size, -.5rem);
    --_ui5_color_picker_slider_handle_height: var(--_ui5-compact-size, 1.5rem)  var(--_ui5-cozy-size, 2rem);
    --_ui5_color_picker_slider_handle_width: var(--_ui5-compact-size, .9375rem)  var(--_ui5-cozy-size, 1.0625rem);
    --_ui5_color_picker_slider_handle_after_height: var(--_ui5-compact-size, 1.25rem)  var(--_ui5-cozy-size, 1.75rem);
    --_ui5_color_picker_slider_handle_focus_height: var(--_ui5-compact-size, 1.625rem)  var(--_ui5-cozy-size, 2.125rem);
    --_ui5_color_picker_colors_wrapper_height: var(--_ui5-compact-size, 1.5rem)  var(--_ui5-cozy-size, 2.25rem);
    --_ui5_color_picker_sliders_height: var(--_ui5-compact-size, 2.25rem)  var(--_ui5-cozy-size, 3rem);
    --_ui5_color_picker_main_color_margin_bottom: var(--_ui5-compact-size, .75rem)  var(--_ui5-cozy-size, 1rem);
    --_ui5_color_picker_slider_spacing: var(--_ui5-compact-size, .8125rem)  var(--_ui5-cozy-size, .9375rem);
    --_ui5_color_channel_toggle_button_width: var(--_ui5-compact-size, 1.375rem)  var(--_ui5-cozy-size, 1.625rem);
    --_ui5_color_channel_toggle_button_margin-top: var(--_ui5-compact-size, -.9375rem)  var(--_ui5-cozy-size, -.75rem);
    --_ui5_color_channel_hex_input_width: var(--_ui5-compact-size, 4.625rem)  var(--_ui5-cozy-size, 4.8125rem);
    --_ui5-color_channel_margin_top: var(--_ui5-compact-size, 0rem)  var(--_ui5-cozy-size, .25rem);
    --_ui5_color-palette-item-height: var(--_ui5-compact-size, 1.25rem)  var(--_ui5-cozy-size, 1.75rem);
    --_ui5_color-palette-item-hover-height: var(--_ui5-compact-size, 1.625rem)  var(--_ui5-cozy-size, 2.375rem);
    --_ui5_color-palette-item-margin: var(--_ui5-compact-size, calc((var(--_ui5_color-palette-item-hover-height) - var(--_ui5_color-palette-item-height)) / 2))  var(--_ui5-cozy-size, calc((var(--_ui5_color-palette-item-hover-height) - var(--_ui5_color-palette-item-height)) / 2));
    --_ui5_color-palette-row-width: var(--_ui5-compact-size, 8.125rem)  var(--_ui5-cozy-size, 12rem);
    --_ui5_color-palette-swatch-container-padding: var(--_ui5-compact-size, .1875rem .8125rem)  var(--_ui5-cozy-size, .3125rem .6875rem);
    --_ui5_datetime_picker_width: var(--_ui5-compact-size, 35.5rem)  var(--_ui5-cozy-size, 40.0625rem);
    --_ui5_datetime_picker_height: var(--_ui5-compact-size, 20.5rem)  var(--_ui5-cozy-size, 25rem);
    --_ui5_datetime_timeview_width: var(--_ui5-compact-size, 17rem)  var(--_ui5-cozy-size, 17rem);
    --_ui5_datetime_timeview_phonemode_width: var(--_ui5-compact-size, 18.5rem)  var(--_ui5-cozy-size, 19.5rem);
    --_ui5_datetime_timeview_phonemode_clocks_width: var(--_ui5-compact-size, 21.125rem)  var(--_ui5-cozy-size, 24.5rem);
    --_ui5_datetime_dateview_phonemode_margin_bottom: var(--_ui5-compact-size, 3.125rem)  var(--_ui5-cozy-size, 0);
    --_ui5_popup_footer_height: var(--_ui5-compact-size, 2.5rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_dialog_content_min_height: var(--_ui5-compact-size, 2.5rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_input_inner_padding: var(--_ui5-compact-size, 0 .5rem)  var(--_ui5-cozy-size, 0 .625rem);
    --_ui5_input_inner_padding_with_icon: var(--_ui5-compact-size, 0 .25rem 0 .5rem)  var(--_ui5-cozy-size, 0 .25rem 0 .625rem);
    --_ui5_input_inner_space_to_tokenizer: var(--_ui5-compact-size, .125rem)  var(--_ui5-cozy-size, .125rem);
    --_ui5_input_inner_space_to_n_more_text: var(--_ui5-compact-size, .25rem)  var(--_ui5-cozy-size, .3125rem);
    --_ui5_input_inner_with_tokenizer_padding_inline_end: var(--_ui5-compact-size, .25rem)  var(--_ui5-cozy-size, .3125rem);
    --_ui5_list_no_data_height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 3rem);
    --_ui5_list_item_cb_margin_right: var(--_ui5-compact-size, .5rem)  var(--_ui5-cozy-size, 0);
    --_ui5_list_item_title_size: var(--_ui5-compact-size, var(--sapFontSize))  var(--_ui5-cozy-size, var(--sapFontLargeSize));
    --_ui5_list_no_data_font_size: var(--_ui5-compact-size, var(--sapFontSize))  var(--_ui5-cozy-size, var(--sapFontLargeSize));
    --_ui5_list_item_img_size: 3rem;
    --_ui5_list_item_img_top_margin: var(--_ui5-compact-size, .55rem)  var(--_ui5-cozy-size, .5rem);
    --_ui5_list_item_img_bottom_margin: .5rem;
    --_ui5_list_item_img_hn_margin: .75rem;
    --_ui5_list_item_dropdown_base_height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.5rem);
    --_ui5_list_item_base_height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, var(--sapElement_LineHeight));
    --_ui5_list_item_base_padding: var(--_ui5-compact-size, 0 1rem)  var(--_ui5-cozy-size, 0 1rem);
    --_ui5_list_item_icon_size: var(--_ui5-compact-size, 1rem)  var(--_ui5-cozy-size, 1.125rem);
    --_ui5_list_item_icon_padding-inline-end: .75rem;
    --_ui5_list_item_selection_btn_margin_top: var(--_ui5-compact-size, calc(-1 * var(--_ui5_checkbox_wrapper_padding)))  var(--_ui5-cozy-size, calc(-1 * var(--_ui5_checkbox_wrapper_padding)));
    --_ui5_list_item_content_vertical_offset: var(--_ui5-compact-size, calc((var(--_ui5_list_item_base_height) - var(--_ui5_list_item_title_size)) / 2))  var(--_ui5-cozy-size, calc((var(--_ui5_list_item_base_height) - var(--_ui5_list_item_title_size)) / 2));
    --_ui5_group_header_list_item_height: 2.75rem;
    --_ui5_month_picker_item_height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 3rem);
    --_ui5_form_item_min_height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.813rem);
    --_ui5_form_item_padding: var(--_ui5-compact-size, .25rem)  var(--_ui5-cozy-size, .65rem);
    --_ui5-form-group-heading-height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_popup_default_header_height: var(--_ui5-compact-size, 2.5rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_year_picker_item_height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 3rem);
    --_ui5_token_height: var(--_ui5-compact-size, 1.25rem)  var(--_ui5-cozy-size, 1.625rem);
    --_ui5_token_icon_size: var(--_ui5-compact-size, .75rem)  var(--_ui5-cozy-size, .75rem);
    --_ui5_token_icon_padding: var(--_ui5-compact-size, .375rem .375rem)  var(--_ui5-cozy-size, .25rem .5rem);
    --_ui5_tc_item_text: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 3rem);
    --_ui5_tc_item_height: var(--_ui5-compact-size, 4rem)  var(--_ui5-cozy-size, 4.75rem);
    --_ui5_tc_item_text_only_height: 2.75rem;
    --_ui5_tc_item_text_only_with_additional_text_height: 3.75rem;
    --_ui5_tc_item_text_line_height: var(--_ui5-compact-size, 1.325rem)  var(--_ui5-cozy-size, 1.325rem);
    --_ui5_tc_item_icon_circle_size: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_tc_item_icon_size: var(--_ui5-compact-size, 1rem)  var(--_ui5-cozy-size, 1.25rem);
    --_ui5_tc_item_add_text_margin_top: var(--_ui5-compact-size, .3125rem)  var(--_ui5-cozy-size, .375rem);
    --_ui5_radio_button_height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_radio_button_label_side_padding: var(--_ui5-compact-size, .5rem)  var(--_ui5-cozy-size, .875rem);
    --_ui5_radio_button_inner_size: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_radio_button_svg_size: var(--_ui5-compact-size, 1rem)  var(--_ui5-cozy-size, 1.375rem);
    --_ui5-responsive_popover_header_height: var(--_ui5-compact-size, 2.5rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5-tree-indent-step: var(--_ui5-compact-size, .5rem)  var(--_ui5-cozy-size, 1.5rem);
    --_ui5-tree-toggle-box-width: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5-tree-toggle-box-height: var(--_ui5-compact-size, 1.5rem)  var(--_ui5-cozy-size, 2.25rem);
    --_ui5-tree-toggle-icon-size: var(--_ui5-compact-size, .8125rem)  var(--_ui5-cozy-size, 1.0625rem);
    --_ui5_split_button_middle_separator_top: -.0625rem;
    --_ui5_split_button_middle_separator_height: var(--_ui5-compact-size, 1.625rem)  var(--_ui5-cozy-size, 2.25rem);
    --_ui5-toolbar-separator-height: var(--_ui5-compact-size, 1.5rem)  var(--_ui5-cozy-size, 2rem);
    --_ui5-toolbar-height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2.75rem);
    --_ui5_toolbar_overflow_padding: var(--_ui5-compact-size, .1875rem .375rem)  var(--_ui5-cozy-size, .25rem .5rem);
    --_ui5_dynamic_page_title_actions_separator_height: var(--_ui5-compact-size, var(--_ui5-toolbar-separator-height))  var(--_ui5-cozy-size, var(--_ui5-toolbar-separator-height));
    --_ui5-shellbar-separator-height: var(--_ui5-compact-size, 2rem)  var(--_ui5-cozy-size, 2rem);
    --___ui5-test-cozy-only: red;
    --___ui5-test-both: var(--_ui5-compact-size, blue)  var(--_ui5-cozy-size, red);
    --___ui5-test-compact-only: var(--_ui5-compact-size, blue) var(--_ui5-cozy-size, var(--_ui5-f2d95f8));
    --_ui5_slider_tooltip_height: var(--_ui5-compact-size, 1rem) var(--_ui5-cozy-size, var(--_ui5-f2d95f8));
    --_ui5_slider_tooltip_padding: var(--_ui5-compact-size, .25rem) var(--_ui5-cozy-size, var(--_ui5-f2d95f8));
    --_ui5_rotation_90deg: rotate(90deg);
    --_ui5_rotation_minus_90deg: rotate(-90deg);
    --_ui5_icon_transform_scale: none;
    --_ui5_panel_toggle_btn_rotation: var(--_ui5_rotation_90deg);
    --_ui5_popover_upward_arrow_margin: .1875rem 0 0 .1875rem;
    --_ui5_popover_right_arrow_margin: .1875rem 0 0 -.375rem;
    --_ui5_popover_downward_arrow_margin: -.375rem 0 0 .125rem;
    --_ui5_popover_left_arrow_margin: .125rem 0 0 .25rem;
    --_ui5_dialog_resize_cursor: se-resize;
    --_ui5_menu_submenu_margin_offset: -.25rem 0
}`